<template>
  <div class="n_content" @wheel="showinfor">
    <div id='map-container'></div>
    <div class="timechart" @click="kChindren">
      <img src="../../../assets/diy/time.png" style="width: 40px;height: 40px;">
      <div style="width: 100%;font-size: 1.2vh;text-align: center;color: #ffffff;">空调时间表</div>
    </div>
    <div class="timechart1" @click="dChindren">
      <img src="../../../assets/diy/time.png" style="width: 40px;height: 40px;">
      <div style="width: 100%;font-size: 1.2vh;text-align: center;color: #ffffff;">照明时间表</div>
    </div>
    <div class="n_header" v-show="echartsShow">
      <div class="n_header_tit" style="font-size: 2vh;padding: 40px 0 0 2.2%">产业2号楼末端能源优化系统项目</div>
      <div class="n_header_tit flex">{{ titleMain }}</div>
      <div class="n_header_tit" style="font-size: 2vh;font-weight: 800;text-align: right;padding: 40px 2.1% 0 0">{{
        homeTime }}&nbsp;&nbsp;&nbsp;&nbsp;{{ weather }}&nbsp;&nbsp;&nbsp;&nbsp;{{ templ }}℃
      </div>
    </div>
    <div class="header_time" v-show="echartsShow">{{ timeDay }}</div>
    <div class="echarts_top" v-show="echartsShow">
      <div class="echarts_top_box">
        <div class="box-header">
          <div class="box-header-left">
            <div class="ech_header" style="font-weight: 800;width: 100%;margin-top: 2%;">能耗及碳排放量统计</div>
            <div style="width: 100%;height: 90%;box-sizing: border-box;padding: 10px 0 0 0;">
              <div class="ech_header" style="margin-bottom: 3%;">
                <div class="ling-box" style="background-color: #FB5343;"></div>{{ ce }}总制热量：<span
                  style="color: #6EDCE4;">{{ len }}kJ</span>
              </div>
              <div class="ech_header" style="margin-bottom: 3%;">
                <div class="ling-box" style="background-color: #26EAB1;"></div>{{ ce }}总用电量：<span
                  style="color: #6EDCE4;">{{ dian }}kW·h/天</span>
              </div>
              <div class="ech_header" style="margin-bottom: 3%;">
                <div class="ling-box" style="background-color: #F99EE4;"></div>{{ ce }}碳排放量：<span
                  style="color: #6EDCE4;">{{ tan }}kg/天</span>
              </div>
            </div>
          </div>
          <div class="box-header-left">
            <div class="ech_header" style="font-weight: 800;width: 100%;margin-top: 2%;">控制模式</div>
            <div style="width: 100%;height: 80%;box-sizing: border-box;">
              <div style=" width: 100%;height: 30%;margin-bottom: 1%;display: flex;justify-content: space-between;">
                <div class="btn-icon flexc" @click="switchModel(1)"><img src="../../../../static/img/sicon/002.png"
                    style="margin-right: 10%;">
                  <span :style="{ color: divColor }">雷达模式</span>
                </div>
                <div class="btn-icon-tit">在工作时段及加班时段自动控制照明及空调运行实现节能与舒适兼顾的无感运行管理.</div>
              </div>
              <div style=" width: 100%;height: 30%;margin-bottom: 1%;display: flex;justify-content: space-between;">
                <div class="btn-icon flexc" @click="switchModel(2)"><img src="../../../../static/img/sicon/003.png"
                    style="margin-right: 10%;" id="wuxiu">
                  <span :style="{ color: divColor1 }">午休模式</span>
                </div>
                <div class="btn-icon-tit">在12：:30至13：30时段关闭照明设备空调静音运行提供舒适的午休环境。</div>
              </div>
              <div style=" width: 100%;height: 30%;margin-bottom: 1%;display: flex;justify-content: space-between;">
                <div class="btn-icon flexc" @click="switchModel(3)"><img src="../../../../static/img/sicon/004.png"
                    style="margin-right: 10%;" id="kongzhi">
                  <span :style="{ color: divColor2 }">一键控制</span>
                </div>
                <div class="btn-icon-tit">在特殊时段如节假日大楼机电设备全部关闭，同时保持设备保护程序运行（如防冻保护）</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-header">
          <div class="box-header-right">
            <div class="box-header-right-l">
              <div class="ech_header"
                style="font-weight: 800;width: 100%;margin-top: 1.5%;margin-left: 2%;font-size: 2vh;color: #D2D2D2;">
                环境数据趋势图
              </div>
              <div ref="pieOne6" id="pieOne6" style="width: 100%; height: 73%;"></div>
            </div>
            <div class="box-header-right-line"></div>
            <div class="box-header-right-r">
              <div class="ech_header"
                style="font-weight: 800;width: 100%;margin-top: 1.5%;margin-left: 5%;font-size: 2vh;color: #D2D2D2;">
                热功耗占比
              </div>

              <div ref="pieOne" id="pieOne" style="width: 100%; height: 73%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="echarts_bottom" v-show="echartsShow">
    </div>
    <!-- <div class="bottom_box" v-show="echartsShow">
      <div class="bottom_box2">
        <div
          style="font-size: 13px;color: #61daff;font-weight: 900;width: 100%;display: flex;justify-content: space-between;">
          <span></span>
          <span>&nbsp;</span>
        </div>
      </div>
    </div> -->
    <div class="dialog_box" v-if="dialogShow">
      <div class="dialog_box_main">
        <div class="dialog_box_header">
          <div class="dialog_box_header_tit">{{ title }}-控制界面</div>
          <i class="el-icon-close" @click="dialogShow = false"></i>
        </div>
        <div class="dialog_box_header_bom"></div>
        <div class="dialog_box_body">
          <div class="dialog-left">
            <div class="dialog-left-top">
              <div class="temp_btn_box">
                <div class="temp_btn_on" @click="switchKtOn" id="btn1">
                  <img src="../../../../static/img/tencent/xueon.png">
                  <div>开空调</div>
                </div>
                <div class="temp_btn_on" @click="switchKtOff" id="btn2">
                  <img src="../../../../static/img/tencent/xueoff.png">
                  <div>关空调</div>
                </div>
              </div>
              <div class="temp_btn_box">
                <div class="temp_btn_on" @click="switchLigOn" id="btn3">
                  <img src="../../../../static/img/tencent/ligon.png">
                  <div>开&nbsp;&nbsp;&nbsp;灯</div>
                </div>
                <div class="temp_btn_on" @click="switchLigOff" id="btn4">
                  <img src="../../../../static/img/tencent/ligoff.png">
                  <div>关&nbsp;&nbsp;&nbsp;灯</div>
                </div>
              </div>
            </div>
            <div class="dialog-left-bottom">
              <div class="bottom_btn" @click="updateTempDel"><span>－</span></div>
              <div class="data_temp_box">
                <div class="s_temp">
                  <div class="temp_tit">设定温度</div>
                  <div class="tepm_data">
                    <span class="temp_data_num">{{ stemp }}</span>
                    <span class="temp_data_unit">℃</span>
                  </div>
                </div>
                <div class="k_temp">
                  <div class="temp_tit">空间温度</div>
                  <div class="tepm_data">
                    <span class="temp_data_num">{{ ktemp }}</span>
                    <span class="temp_data_unit">℃</span>
                  </div>
                </div>
              </div>
              <div class="bottom_btn" @click="updateTempAdd"><span>＋</span></div>
            </div>
            <div class="dialog-right_top">
              <span style="margin-right: 20px;">雷达模式</span>
              <div class="switch_diy">
                <el-switch v-model="valuecheck" active-color="#070B27" inactive-color="#070B27" @change="updateLeida">
                </el-switch>
              </div>
              <span style="margin-left: 20px;">手动模式</span>
            </div>
          </div>
          <div class="dialog-center"></div>
          <div class="dialog-right">
            <!--  <div class="dialog-right_top">
              <span style="margin-right: 20px;">雷达模式</span>
              <div class="switch_diy">
                <el-switch v-model="valuecheck" active-color="#070B27" inactive-color="#070B27" @change="updateLeida">
                </el-switch>
              </div>
              <span style="margin-left: 20px;">手动模式</span>
            </div> -->
            <div class="dialog-right_bottom">
              <div class="bottom-box1">
                <div class="bottom-box-left">今日运行时间：</div>
                <div class="bottom-box-right">{{ qydata.workHours }}</div>
              </div>

              <div class="bottom-box1">
                <div class="bottom-box-left">今日用电量：</div>
                <div class="bottom-box-right">{{ qydata.electricity }}kW·h</div>
              </div>

              <div class="bottom-box1">
                <div class="bottom-box-left">今日制冷量：</div>
                <div class="bottom-box-right">{{ qydata.totalCP }}kJ</div>
              </div>
              <div class="bottom-box1">
                <div class="bottom-box-left">当前制冷功率：</div>
                <div class="bottom-box-right">{{ qydata.cp }}kW</div>
              </div>

              <div class="bottom-box1">
                <div class="bottom-box-left">当前制热功率：</div>
                <div class="bottom-box-right">{{ qydata.hp }}kW</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fanone ref="fanOne"></fanone>
    <timeChare ref="timeChar"></timeChare>
    <div class="men-box" v-if="menShow">
      <div class="men-box-main">
        <div class="men-box-main-header">
          <div style="color:#fff;font-size: 15px">门禁</div>
          <i class="el-icon-close" @click="menShow = false" style="font-size: 15px;color: #fff;cursor: pointer;"></i>
        </div>
        <div class="men_box_header_bom"></div>
        <div class="men_box_body">
          <span style="color: #fff;">关门</span>
          <div class="switch_diy">
            <el-switch v-model="menData" active-color="#070B27" inactive-color="#070B27" @change="updateKaimen">
            </el-switch>
          </div>
          <span style="color: #fff;">开门</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import vjmap, { isGeoPointLike } from 'vjmap';
import ToolTip from "@/components/vjmapUtil/ToolTip";
import echarts from 'echarts';
import UILayer from '@/components/vjmapUtil/UILayer';
import 'vjmap/dist/vjmap.min.css';
import service from '../../../service/leftService.js'
import { color } from 'echarts/lib/export';
import { mapState, mapMutations, mapActions } from "vuex";
import fanone from './fanone.vue'
import timeChare from './timeChare.vue'
export default {
  data() {
    return {
      pieOne: null,
      bi11: '',
      bi12: '',
      bi13: '',
      bi14: '',
      bi15: '',
      menData: false,
      menShow: false,
      divColor: "#FFF",
      divColor1: "#FFF",
      divColor2: "#FFF",
      templ: '',
      homeTime: '',
      weather: '',
      model: '上班模式',
      len: '',
      dian: '',
      tan: "",
      mtan: '',
      qydata: {
        cp: '0',
        electricity: '0',
        hp: '0',
        totalCP: '0',
        workHours: '0',
      },
      valuecheck: true, // 雷达手动
      stemp: '00.0',//设定温度
      ktemp: '00.0',//空间温度
      titleMain: "江宁基地B2建筑5层",
      echartsShow: true,
      dialogShow: false,
      title: "设备",
      map: null,
      cadId: 'c45cc7e84c29',
      polygons: [
      ], // 承接色块
      polygon: null, // 添加覆盖物
      points: [{
        lig: 1,
        other: "北五区",
        name: 'BW_NO1',
        sn: "B2-532",
        icuId: '664f4a4edb111b252056d5a1',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 26169.8687, y: 20982.4732 },
          { x: 17889.7943, y: 20982.4747 },
          { x: 17889.8687, y: 13786.4821 },
          { x: 26169.8687, y: 13786.4732 },
        ]
      },
      {
        lig: 1,
        other: "北四区",
        name: 'BW_NO2',
        sn: "B2-534",
        icuId: '664f4f7ddb111b252056d608',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 26989.868748, y: 20982.475072 },
          { x: 26989.868748, y: 13786.473546 },
          { x: 35169.868748, y: 13786.473546 },
          { x: 35169.868748, y: 20982.475072 },
        ]
      }, {
        lig: 1,
        other: "北三区",
        name: 'BW_NO16',
        sn: "B2-536",
        icuId: '664f5364db111b252056d66f',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 35989.7943, y: 20982.4751 },
          { x: 44169.7943, y: 20982.4751 },
          { x: 44169.7943, y: 13786.4735 },
          { x: 35989.7943, y: 13786.4735 },
        ]
      }, {
        lig: 1,
        other: "北二区",
        name: 'BW_NO9',
        sn: "B2-538",
        icuId: '664f546bdb111b252056d6d6',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 44989.8687, y: 20982.4751 },
          { x: 53169.8687, y: 20982.4751 },
          { x: 53169.8687, y: 13786.4735 },
          { x: 44989.8687, y: 13786.4735 },
        ]
      }, {
        lig: 1,
        other: "北一区",
        name: 'BW_NO12',
        sn: "B2-540",
        color: "rgba(0, 81, 255, 0)",
        icuId: '664b36c0db111b252056d2d5',
        point: [
          { x: 53989.7943, y: 20982.4751 },
          { x: 62879.8687, y: 20982.4751 },
          { x: 62879.8687, y: 13786.4735 },
          { x: 53989.7943, y: 13786.4735 },
        ]
      }, {
        lig: 1,
        other: "南五区",
        name: 'BW_NO13',
        sn: "B2-533",
        color: "rgba(0, 81, 255, 0)",
        icuId: '664e21a4db111b252056d480',
        point: [
          { x: 17889.7943, y: 11607.4732 },
          { x: 26169.8687, y: 11607.4732 },
          { x: 26169.8687, y: 4411.4732 },
          { x: 17889.7943, y: 4411.4732 },

        ]
      }, {
        lig: 1,
        other: "南四区",
        name: 'BW_NO14',
        sn: "B2-535",
        color: "rgba(0, 81, 255, 0)",
        icuId: '664e21ebdb111b252056d4bf',
        point: [
          { x: 26989.8687, y: 11607.4732 },
          { x: 35169.8687, y: 11607.4732 },
          { x: 35169.8687, y: 4411.4732 },
          { x: 26989.8687, y: 4411.4732 },

        ]
      }, {
        lig: 1,
        other: "南三区",
        name: 'BW_NO15',
        sn: "B2-537",
        color: "rgba(0, 81, 255, 0)",
        icuId: '664f56d4db111b252056d7a4',
        point: [
          { x: 35989.7943, y: 11607.4732 },
          { x: 44169.7943, y: 11607.4732 },
          { x: 44169.7943, y: 4411.4732 },
          { x: 35989.7943, y: 4411.4732 },
        ]
      }, {
        lig: 1,
        other: "南二区",
        name: 'BW_NO10',
        sn: "B2-539",
        color: "rgba(0, 81, 255, 0)",
        icuId: '664e1d98db111b252056d441',
        point: [
          { x: 44989.8687, y: 11607.4732 },
          { x: 53169.8687, y: 11607.4732 },
          { x: 53169.8687, y: 4411.4732 },
          { x: 44989.8687, y: 4411.4732 },
        ]
      }, {
        lig: 1,
        other: "南一区",
        name: 'BW_NO11',
        sn: "B2-541",
        icuId: '664ccb24db111b252056d402',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 53989.7943, y: 11607.4732 },
          { x: 62479.8065, y: 11607.4732 },
          { x: 62479.8065, y: 4411.4732 },
          { x: 53989.7943, y: 4411.4732 },

        ]
      }, {
        lig: 2,
        other: "523室",
        name: '523',
        sn: "B2-523",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652da53db111b252056da74',
        point: [
          { x: 8679.8735, y: 31411.4791 },
          { x: 8679.8735, y: 25411.4821 },
          { x: 17479.8735, y: 25411.4821 },
          { x: 17479.8735, y: 31411.4791 },
        ]
      }, {
        lig: 1,
        other: "522室",
        name: '522',
        sn: "B2-522",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652d68adb111b252056d9f1',
        point: [
          { x: 17679.8735, y: 31411.4791 },
          { x: 21979.8735, y: 31411.4791 },
          { x: 21979.8735, y: 25411.4821 },
          { x: 17679.8735, y: 25411.4821 },

        ]
      }, {
        lig: 1,
        other: "521室",
        name: '521',
        sn: "B2-521",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652d44cdb111b252056d9c4',
        point: [
          { x: 22179.8735, y: 31411.4791 },
          { x: 26479.8735, y: 31411.4791 },
          { x: 26479.8735, y: 25411.4821 },
          { x: 22179.8735, y: 25411.4821 },
        ]
      }, {
        lig: 2,
        other: "519室",
        name: '519',
        sn: "B2-519",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6655c63b5ad393313cfe9328',
        point: [
          { x: 29679.8735, y: 31411.4791 },
          { x: 35479.8687, y: 31411.4791 },
          { x: 35479.8687, y: 25411.4821 },
          { x: 29679.8735, y: 25411.4821 },
        ]
      }, {
        lig: 1,
        other: "518室",
        name: '518',
        sn: "B2-518",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652d1a0db111b252056d997',
        point: [
          { x: 35679.8687, y: 31411.4791 },
          { x: 39979.8735, y: 31411.4791 },
          { x: 39979.8735, y: 25411.4821 },
          { x: 35679.8687, y: 25411.4821 },
        ]
      }, {
        lig: 1,
        other: "517室",
        name: '517',
        sn: "B2-517",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652cfe7db111b252056d96a',
        point: [
          { x: 40179.8735, y: 31411.4791 },
          { x: 44479.8735, y: 31411.4791 },
          { x: 44479.8735, y: 25411.4821 },
          { x: 40179.8735, y: 25411.4821 },
        ]
      }, {
        lig: 1,
        other: "516室",
        name: '516',
        sn: "B2-516",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652cf5bdb111b252056d93d',
        point: [
          { x: 44679.8735, y: 31411.4791 },
          { x: 48979.8735, y: 31411.4791 },
          { x: 48979.8735, y: 25411.4821 },
          { x: 44679.8735, y: 25411.4821 },
        ]
      }, {
        lig: 2,
        other: "515室",
        name: '515',
        sn: "B2-515",
        color: "rgba(0, 81, 255, 0)",
        icuId: '66537c27db111b252056dbca',
        point: [
          { x: 49179.8735, y: 31411.4791 },
          { x: 53479.8735, y: 31411.4791 },
          { x: 53479.8735, y: 25411.4821 },
          { x: 49179.8735, y: 25411.4821 },
        ]
      }, {
        lig: 1,
        other: "513室",
        name: '513',
        sn: "B2-513",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6651cac6db111b252056d8b4',
        point: [
          { x: 53679.8735, y: 31411.4791 },
          { x: 57979.8735, y: 31411.4791 },
          { x: 57979.8735, y: 25411.4821 },
          { x: 53679.8735, y: 25411.4821 },

        ]
      }, {
        lig: 2,
        other: "512室",
        name: '512',
        sn: "B2-512",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6651f146db111b252056d8e1',
        point: [
          { x: 58179.8735, y: 31411.4791 },
          { x: 62479.8736, y: 31411.4791 },
          { x: 62479.8736, y: 25411.4821 },
          { x: 58179.8735, y: 25411.4821 },

        ]
      }, {
        lig: 2,
        other: "511室",
        name: '511',
        sn: "B2-511",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6651f2a6db111b252056d90e',
        point: [
          { x: 62679.8735, y: 31411.4791 },
          { x: 66979.8735, y: 31411.4791 },
          { x: 66979.8735, y: 25411.4821 },
          { x: 62679.8735, y: 25411.4821 },
        ]
      }, {
        lig: 2,
        other: "510室",
        name: '510',
        sn: "B2-510",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665057c1db111b252056d7f4',
        point: [
          { x: 67179.8735, y: 32211.4821 },
          { x: 71679.8735, y: 32211.4821 },
          { x: 71679.8735, y: 21751.4806 },
          { x: 67179.8735, y: 21751.4806 },

        ]
      }, {
        lig: 2,
        other: "509室",
        name: '509',
        sn: "B2-509",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6651c4a6db111b252056d872',
        point: [
          { x: 67179.8735, y: 21351.4806 },
          { x: 71679.8735, y: 21351.4806 },
          { x: 71679.8735, y: 13011.4821 },
          { x: 67179.8735, y: 13011.4821 },
        ]
      }, {
        lig: 2,
        other: "526室",
        name: '526',
        sn: "B2-526",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652d841db111b252056da1e',
        point: [
          { x: 8679.8735, y: 25211.4808 },
          { x: 15054.8687, y: 25211.4808 },
          { x: 15054.8687, y: 13011.4821 },
          { x: 8679.8735, y: 13011.4821 },
        ]
      }, {
        lig: 1,
        other: "529室",
        name: '529',
        sn: "B2-529",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652d841db111b252056da1e',
        point: [
          { x: 219.8735, y: 25611.4821 },
          { x: 5279.8735, y: 25611.4821 },
          { x: 5279.8735, y: 20761.4785 },
          { x: 219.8735, y: 20761.4785 },

        ]
      }, {
        lig: 1,
        other: "503室",
        name: '503',
        sn: "B2-503",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6652dde4db111b252056dab6',
        point: [
          { x: 13179.8735, y: 10311.4821 },
          { x: 17279.8687, y: 10311.4821 },
          { x: 17279.8687, y: 3311.4821 },
          { x: 13179.8735, y: 3311.4821 },
        ]
      }, {
        lig: 1,
        other: "空调机房",
        name: '544风机盘管数据接口',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 8679.8735, y: 10311.4821 },
          { x: 12979.8735, y: 10311.4821 },
          { x: 12979.8735, y: 3311.4821 },
          { x: 8679.8735, y: 3311.4821 },
        ]
      }, {
        lig: 1,
        other: "空调机房",
        name: '543风机盘管数据接口',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 62679.8810, y: 10311.4821 },
          { x: 66979.8811, y: 10311.4821 },
          { x: 66979.8811, y: 3311.4821 },
          { x: 62679.8810, y: 3311.4821 },
        ]
      }, /* {
        lig: 1,
        other: "弱电间",
        name: '弱电间',
        sn: "",
        icuId: '',
        color: "rgba(0, 81, 255, 0)",
        point: [
          { x: 67179.8811, y: 10311.4821 },
          { x: 69479.8811, y: 10311.4821 },
          { x: 69479.8811, y: 6611.4821 },
          { x: 67179.8811, y: 6611.4821 },
        ]
      }, {
        lig: 1,
        other: "强电间",
        name: '强电间',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 69679.8811, y: 10311.4821 },
          { x: 71679.8810, y: 10311.4821 },
          { x: 71679.8810, y: 6611.4821 },
          { x: 69679.8811, y: 6611.4821 },
        ]
      }, {
        lig: 1,
        other: "储藏室",
        name: '储藏室',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 67179.8811, y: 6411.4821 },
          { x: 67179.8811, y: 6611.4821 },
          { x: 71679.8810, y: 6411.4821 },
          { x: 71679.8810, y: 6611.4821 },

        ]
      }, {
        lig: 1,
        other: "电梯厅",
        name: '电梯厅',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 71879.8810, y: 12811.4852 },
          { x: 77579.8735, y: 12811.4852 },
          { x: 77579.8735, y: 4161.4821 },
          { x: 71879.8810, y: 4161.4821 },
        ]
      }, {
        lig: 1,
        other: "茶水间",
        name: '茶水间',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 72679.8735, y: 17461.0865 },
          { x: 75079.8735, y: 17461.0865 },
          { x: 75079.8735, y: 13011.4821 },
          { x: 72679.8735, y: 13011.4821 },
        ]
      },
      {
        lig: 1,
        other: "卫生间",
        name: '卫生间',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 71909.8735, y: 25581.4821 },
          { x: 71909.8735, y: 21321.4806 },
          { x: 73109.8735, y: 21351.4806 },
          { x: 73109.8735, y: 20541.4826 },
          { x: 75049.8737, y: 20541.4826 },
          { x: 75049.8737, y: 22141.4826 },
          { x: 77509.8737, y: 22141.4826 },
          { x: 77509.8737, y: 20541.4806 },
          { x: 80249.8735, y: 20541.4806 },
          { x: 80679.8661, y: 20941.4806 },
          { x: 80679.8661, y: 25181.4806 },
          { x: 80249.8565, y: 25181.4806 },
          { x: 80249.8565, y: 25581.4821 },
        ]
      }, {
        lig: 1,
        other: "电梯厅",
        name: '电梯厅',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 219.8735, y: 20561.4786 },
          { x: 219.8735, y: 4511.4806 },
          { x: 8479.8735, y: 4511.4806 },
          { x: 8479.8735, y: 12811.4821 },
          { x: 5279.4664, y: 12811.4821 },
          { x: 5279.4664, y: 20561.4785 },
        ]
      }, */
      {
        lig: 1,
        other: "门禁",
        name: '右侧门禁',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 70392.57036334946, y: 12340.039300285745 },
          { x: 72639.52393880475, y: 12340.039300285745 },
          { x: 72639.52393880475, y: 10949.783743566208 },
          { x: 70392.57036334946, y: 10949.783743566208 },
        ]
      },
      {
        lig: 1,
        other: "门禁",
        name: '左侧门禁',
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 7755.2939243296205, y: 12351.761347857959 },
          { x: 9885.22959259274, y: 12351.761347857959 },
          { x: 9885.22959259274, y: 10949.783743566208 },
          { x: 7755.2939243296205, y: 10949.783743566208 },
        ]
      }],
      points1: [{
        lig: 1,
        other: "B2一层北四区",
        name: "BW_NO15",
        sn: "B2-132",
        color: "rgba(0, 81, 255, 0)", icuId: '66656f531ec2056d751fc266',
        point: [
          { x: 18803.1501, y: 33234.1471 },
          { x: 27203.1501, y: 33234.1471 },
          { x: 27203.1501, y: 24834.1486 },
          { x: 18803.1501, y: 24834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层北三区",
        name: "BW_NO16",
        sn: "B2-134",
        color: "rgba(0, 81, 255, 0)", icuId: '666598aa1ec2056d751fc354',
        point: [
          { x: 27803.1501, y: 33234.1471 },
          { x: 36203.1501, y: 33234.1471 },
          { x: 36203.1501, y: 24834.1486 },
          { x: 27803.1501, y: 24834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层北二区",
        name: "BW_NO13",
        sn: "B2-136",
        color: "rgba(0, 81, 255, 0)", icuId: '6665a0871ec2056d751fc406',
        point: [
          { x: 36803.1501, y: 33234.1471 },
          { x: 45203.1501, y: 33234.1471 },
          { x: 45203.1501, y: 24834.1486 },
          { x: 36803.1501, y: 24834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层北一区",
        name: "BW_NO12",
        sn: "B2-138",
        color: "rgba(0, 81, 255, 0)", icuId: '6665a6331ec2056d751fc4b8',
        point: [
          { x: 45803.1501, y: 33234.1471 },
          { x: 54203.1501, y: 33234.1471 },
          { x: 54203.1501, y: 24834.1486 },
          { x: 45803.1501, y: 24834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层南四区",
        name: "BW_NO9",
        sn: "B2-133",
        color: "rgba(0, 81, 255, 0)", icuId: '666572971ec2056d751fc2ab',
        point: [
          { x: 18803.1501, y: 24234.1486 },
          { x: 27203.1501, y: 24234.1486 },
          { x: 27203.1501, y: 15834.1486 },
          { x: 18803.1501, y: 15834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层南三区",
        name: "BW_NO10",
        sn: "B2-135",
        color: "rgba(0, 81, 255, 0)", icuId: '66659a8f1ec2056d751fc399',
        point: [
          { x: 27803.1501, y: 24234.1486 },
          { x: 36203.1501, y: 24234.1486 },
          { x: 36203.1501, y: 15834.1486 },
          { x: 27803.1501, y: 15834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层南二区",
        name: "BW_NO11",
        sn: "B2-137",
        color: "rgba(0, 81, 255, 0)", icuId: '6665a2dc1ec2056d751fc44b',
        point: [
          { x: 36803.1501, y: 24234.1486 },
          { x: 45203.1501, y: 24234.1486 },
          { x: 45203.1501, y: 15834.1486 },
          { x: 36803.1501, y: 15834.1486 },
        ],
      },
      {
        lig: 1,
        other: "B2一层南一区",
        name: "BW_NO14",
        sn: "B2-139",
        color: "rgba(0, 81, 255, 0)", icuId: '6665a8f31ec2056d751fc4fd',
        point: [
          { x: 45803.1501, y: 24234.1486 },
          { x: 54203.1501, y: 24234.1486 },
          { x: 54203.1501, y: 15834.1486 },
          { x: 45803.1501, y: 15834.1486 },
        ],
      },
      {
        lig: 1,
        other: "102室",
        name: "102",
        sn: "B2-102",
        color: "rgba(0, 81, 255, 0)", icuId: '6668018e4814d9682916ddab',
        point: [
          { x: 14103.721731809375, y: 12734.1501 },
          { x: 18302.961273528155, y: 12734.1501 },
          { x: 18302.961273528155, y: 5734.1501 },
          { x: 14103.721731809375, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "103室",
        name: "103",
        sn: "B2-103",
        color: "rgba(0, 81, 255, 0)", icuId: '66680b604814d9682916ddee',
        point: [
          { x: 18503.159085182924, y: 12734.1501 },
          { x: 22702.023539101574, y: 12734.1501 },
          { x: 22702.023539101574, y: 5734.1501 },
          { x: 18503.159085182924, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "105室",
        name: "105",
        sn: "B2-105",
        color: "rgba(0, 81, 255, 0)", icuId: '666688844814d9682916db3d',
        point: [
          { x: 22902.155427872698, y: 12734.1501 },
          { x: 27403.168570472422, y: 12734.1501 },
          { x: 27403.168570472422, y: 5734.1501 },
          { x: 22902.155427872698, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "106室",
        name: "106",
        sn: "B2-106",
        color: "rgba(0, 81, 255, 0)", icuId: '66668ca84814d9682916db7e',
        point: [
          { x: 27603.170120837152, y: 12734.1501 },
          { x: 31651.154339781497, y: 12734.1501 },
          { x: 31651.154339781497, y: 5734.1501 },
          { x: 27603.170120837152, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "107室",
        name: "107",
        sn: "B2-107",
        color: "rgba(0, 81, 255, 0)", icuId: '666693e14814d9682916dbaf',
        point: [
          { x: 31851.88167943465, y: 12734.1501 },
          { x: 36300.565262695935, y: 12734.1501 },
          { x: 36300.565262695935, y: 5734.1501 },
          { x: 31851.88167943465, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "108室",
        name: "108",
        sn: "B2-108",
        color: "rgba(0, 81, 255, 0)", icuId: '66669b134814d9682916dbdd',
        point: [
          { x: 36500.81555879422, y: 12734.1501 },
          { x: 40950.05324095633, y: 12734.1501 },
          { x: 40950.05324095633, y: 5734.1501 },
          { x: 36500.81555879422, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "109室",
        name: "109",
        sn: "B2-109",
        color: "rgba(0, 81, 255, 0)", icuId: '66669df74814d9682916dc0b',
        point: [
          { x: 41151.93981121895, y: 12734.1501 },
          { x: 45602.5287969309, y: 12734.1501 },
          { x: 45602.5287969309, y: 5734.1501 },
          { x: 41151.93981121895, y: 5734.1501 },
        ],
      },
      {
        lig: 1,
        other: "110室",
        name: "110",
        sn: "B2-110",
        color: "rgba(0, 81, 255, 0)", icuId: '6666a92a4814d9682916dc39',
        point: [
          { x: 45803.11029832723, y: 12734.130496819445 },
          { x: 54402.51399013196, y: 12734.130496819445 },
          { x: 54402.51399013196, y: 5733.542212427681 },
          { x: 45803.11029832723, y: 5733.542212427681 },
        ],
      },
      {
        lig: 1,
        other: "117室",
        name: "117",
        sn: "B2-117",
        color: "rgba(0, 81, 255, 0)", icuId: '6666b2734814d9682916dcd1',
        point: [
          { x: 57803.1501, y: 21034.5227 },
          { x: 63600.7880, y: 21034.5227 },
          { x: 63600.7880, y: 15440.5635 },
          { x: 57803.1501, y: 15440.5635 },
        ],
      },
      /* {
        lig: 1,
        other: "117室",
        name: "117",
        sn: "B2-117",
        color: "rgba(0, 81, 255, 0)",icuId:'',
        point: [
          { x: 57803.1501, y: 21034.5227 },
          { x: 63600.7880, y: 21034.5227 },
          { x: 63600.7880, y: 15440.5635 },
          { x: 57803.1501, y: 15440.5635 },
        ],
      }, */
      {
        lig: 1,
        other: "119室",
        name: "119",
        sn: "B2-119",
        color: "rgba(0, 81, 255, 0)", icuId: '6666b5844814d9682916dd55',
        point: [
          { x: 54603.1534, y: 33834.1471 },
          { x: 63603.1501, y: 33834.1471 },
          { x: 63603.1501, y: 27034.8968 },
          { x: 54603.1534, y: 27034.8968 },
        ],
      },],
      points2: [{
        lig: 1,
        other: "213室",
        name: "AIR_HUM_EXIS",
        sn: "B2-211",
        color: "rgba(0, 81, 255, 0)",
        icuId: '66640c721ec2056d751fbfcd',
        point: [
          { x: 106225.6254, y: 41675.7968 },
          { x: 114625.6254, y: 41675.7968 },
          { x: 114625.6254, y: 33275.7968 },
          { x: 106225.6254, y: 33275.7968 },
        ],
      },
      {
        lig: 1,
        other: "215室",
        name: "AIR_HUM_EXIS",
        sn: "B2-212",
        color: "rgba(0, 81, 255, 0)",
        icuId: '66640c721ec2056d751fbfcd',
        point: [
          { x: 106225.6254, y: 50675.7953 },
          { x: 114625.6254, y: 50675.7953 },
          { x: 114625.6254, y: 42275.7968 },
          { x: 106225.6254, y: 42275.7968 },
        ],
      }, {
        lig: 1,
        other: "B2二层218室北",
        name: "AIR_HUM_EXIS",
        sn: "B2-232",
        color: "rgba(0, 81, 255, 0)", icuId: '6662cc461ec2056d751fbd12',
        point: [
          { x: 61225.6254, y: 50675.7953 },
          { x: 72780.6254, y: 50675.7953 },
          { x: 72780.6254, y: 42275.7968 },
          { x: 61225.6254, y: 42275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层218室南",
        name: "AIR_HUM_EXIS",
        sn: "B2-233",
        color: "rgba(0, 81, 255, 0)", icuId: '6662cf571ec2056d751fbd7f',
        point: [
          { x: 61325.6254, y: 41625.7968 },
          { x: 72780.6254, y: 41625.7968 },
          { x: 72780.6254, y: 33275.7968 },
          { x: 61325.6254, y: 33275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层217室北",
        name: "AIR_HUM_EXIS",
        sn: "B2-234",
        color: "rgba(0, 81, 255, 0)", icuId: '6662c88e1ec2056d751fbca5',
        point: [
          { x: 75602.6254, y: 50675.7953 },
          { x: 87625.6254, y: 50675.7953 },
          { x: 87625.6254, y: 42275.7968 },
          { x: 75602.6254, y: 42275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层217室南",
        name: "AIR_HUM_EXIS",
        sn: "B2-235",
        color: "rgba(0, 81, 255, 0)", icuId: '6662d4a91ec2056d751fbdec',
        point: [
          { x: 75602.6254, y: 41675.7968 },
          { x: 87625.6254, y: 41675.7968 },
          { x: 87625.6254, y: 33275.7968 },
          { x: 75602.6254, y: 33275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层216室西北",
        name: "AIR_HUM_EXIS",
        sn: "B2-236",
        color: "rgba(0, 81, 255, 0)", icuId: '6662c4a91ec2056d751fbc38',
        point: [
          { x: 88225.6254, y: 50675.7953 },
          { x: 96625.6254, y: 50675.7953 },
          { x: 96625.6254, y: 42275.7968 },
          { x: 88225.6254, y: 42275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层216室西南",
        name: "AIR_HUM_EXIS",
        sn: "B2-237",
        color: "rgba(0, 81, 255, 0)", icuId: '6662db911ec2056d751fbe45',
        point: [
          { x: 88225.6254, y: 41675.7968 },
          { x: 96625.6254, y: 41675.7968 },
          { x: 96625.6254, y: 33275.7968 },
          { x: 88225.6254, y: 33275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层216室东北",
        name: "AIR_HUM_EXIS",
        sn: "B2-238",
        color: "rgba(0, 81, 255, 0)", icuId: '6662bbf91ec2056d751fbbcb',
        point: [
          { x: 97225.6254, y: 50675.7953 },
          { x: 105625.6254, y: 50675.7953 },
          { x: 105625.6254, y: 42275.7968 },
          { x: 97225.6254, y: 42275.7968 },
        ],
      },
      {
        lig: 1,
        other: "B2二层216室东南",
        name: "AIR_HUM_EXIS",
        sn: "B2-239",
        color: "rgba(0, 81, 255, 0)", icuId: '6664174d1ec2056d751fc026',
        point: [
          { x: 97225.6254, y: 41675.7968 },
          { x: 105625.6254, y: 41675.7968 },
          { x: 105625.6254, y: 33275.7968 },
          { x: 97225.6254, y: 33275.7968 },
        ],
      },
      {
        // x: 72825.61843643253, y: 30160.798458630496
        lig: 1,
        other: "202室",
        name: "AIR_HUM_EXIS",
        sn: "B2-202",
        color: "rgba(0, 81, 255, 0)", icuId: '666461151ec2056d751fc20d',
        point: [
          { x: 65525.6302, y: 30175.7983 },
          { x: 72825.6184, y: 30175.7983 },
          { x: 72825.6184, y: 23175.7983 },
          { x: 65525.6302, y: 23175.7983 },
        ],
      },
      {
        lig: 1,
        other: "219室",
        name: "AIR_HUM_EXIS",
        sn: "B2-219",
        color: "rgba(0, 81, 255, 0)", icuId: '',
        point: [
          { x: 73025.6254, y: 30160.7999 },
          { x: 77619.9056, y: 30160.7999 },
          { x: 77619.9056, y: 23175.7983 },
          { x: 73025.6254, y: 23175.7983 },
        ],
      },
      {
        lig: 1,
        other: "220室",
        name: "AIR_HUM_EXIS",
        sn: "B2-220",
        color: "rgba(0, 81, 255, 0)", icuId: '66645c2b1ec2056d751fc1ab',
        point: [
          { x: 77739.87587552483, y: 30160.7997 },
          { x: 82107.21107162297, y: 30160.7997 },
          { x: 82107.21107162297, y: 23175.7983 },
          { x: 77739.87587552483, y: 23175.7983 },
        ],
      },
      {
        lig: 1,
        other: "221室",
        name: "AIR_HUM_EXIS",
        sn: "B2-221",
        color: "rgba(0, 81, 255, 0)", icuId: '66645d541ec2056d751fc1dc',
        point: [
          { x: 82227.82174194918, y: 30160.7995 },
          { x: 86595.67880021522, y: 30160.7995 },
          { x: 86595.67880021522, y: 23175.7983 },
          { x: 82227.82174194918, y: 23175.7983 },
        ],
      },
      {
        lig: 1,
        other: "203室",
        name: "AIR_HUM_EXIS",
        sn: "B2-203",
        color: "rgba(0, 81, 255, 0)", icuId: '66645ac91ec2056d751fc17a',
        point: [
          { x: 86716.18342999471, y: 30160.7990 },
          { x: 92615.24408806162, y: 30160.7990 },
          { x: 92615.24408806162, y: 23175.7983 },
          { x: 86716.18342999471, y: 23175.7983 },
        ],
      },
      {
        lig: 1,
        other: "205室",
        name: "AIR_HUM_EXIS",
        sn: "B2-205",
        color: "rgba(0, 81, 255, 0)", icuId: '666457711ec2056d751fc149',
        point: [
          { x: 96997.6256, y: 30160.7990 },
          { x: 101365.6498, y: 30160.7990 },
          { x: 101365.6498, y: 23390.7970 },
          { x: 96997.6256, y: 23390.7970 },
        ],
      },
      {
        lig: 1,
        other: "206室",
        name: "AIR_HUM_EXIS",
        sn: "B2-206",
        color: "rgba(0, 81, 255, 0)", icuId: '66644f4d1ec2056d751fc0ff',
        point: [
          { x: 101485.6501, y: 30175.7992 },
          { x: 105825.6254, y: 30175.7992 },
          { x: 105825.6254, y: 23390.7970 },
          { x: 101485.6501, y: 23390.7970 },
        ],
      },
      {
        lig: 1,
        other: "207室",
        name: "AIR_HUM_EXIS",
        sn: "B2-207",
        color: "rgba(0, 81, 255, 0)", icuId: '66644d7d1ec2056d751fc0ce',
        point: [
          { x: 105985.6256, y: 30175.7987 },
          { x: 110365.6668, y: 30175.7987 },
          { x: 110365.6668, y: 23390.7970 },
          { x: 105985.6256, y: 23390.7970 },
        ],
      },
      {
        lig: 1,
        other: "208室",
        name: "AIR_HUM_EXIS",
        sn: "B2-208",
        color: "rgba(0, 81, 255, 0)", icuId: '66644b941ec2056d751fc09d',
        point: [
          { x: 110485.6670, y: 30175.7985 },
          { x: 114825.6254, y: 30175.7985 },
          { x: 114825.6254, y: 23390.7970 },
          { x: 110485.6670, y: 23390.7970 },
        ],
      }],
      points3: [
        {
          lig: 1,
          other: "B2三层北五区",
          name: "北5",
          sn: "B2-332",
          icuId: '665dcf37a3265241f4e92a8f',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 17878.9717, y: 21810.2548 },
            { x: 26278.9717, y: 21810.2548 },
            { x: 26278.9717, y: 13410.2548 },
            { x: 17878.9717, y: 13410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层北四区",
          name: "北4",
          sn: "B2-334",
          color: "rgba(0, 81, 255, 0)",
          icuId: '665dcc35a3265241f4e92a27',
          point: [
            { x: 26878.9717, y: 21810.2548 },
            { x: 35278.9717, y: 21810.2548 },
            { x: 35278.9717, y: 13410.2548 },
            { x: 26878.9717, y: 13410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层北三区",
          name: "北3",
          sn: "B2-336",
          color: "rgba(0, 81, 255, 0)", icuId: '665dc324a3265241f4e9297f',
          point: [
            { x: 35878.9717, y: 21810.2548 },
            { x: 44278.9717, y: 21810.2548 },
            { x: 44278.9717, y: 13410.2548 },
            { x: 35878.9717, y: 13410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层北二区",
          name: "北2",
          sn: "B2-338",
          color: "rgba(0, 81, 255, 0)", icuId: '665d75fda3265241f4e9289a',
          point: [
            { x: 44878.9717, y: 21810.2548 },
            { x: 53278.9717, y: 21810.2548 },
            { x: 53278.9717, y: 13410.2548 },
            { x: 44878.9717, y: 13410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层北一区",
          name: "北1",
          sn: "B2-340",
          color: "rgba(0, 81, 255, 0)", icuId: '665d6d1b3185241b66ee69a5',
          point: [
            { x: 53878.9717, y: 21810.2548 },
            { x: 62278.9717, y: 21810.2548 },
            { x: 62278.9717, y: 13410.2548 },
            { x: 53878.9717, y: 13410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层南五区",
          name: "南5",
          sn: "B2-333",
          color: "rgba(0, 81, 255, 0)", icuId: '665dcf37a3265241f4e92a8f',
          point: [
            { x: 17878.9717, y: 12810.2548 },
            { x: 26278.9717, y: 12810.2548 },
            { x: 26278.9717, y: 4410.2548 },
            { x: 17878.9717, y: 4410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层南四区",
          name: "南4",
          sn: "B2-335", icuId: '665dc5b1a3265241f4e929e7',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 26878.9717, y: 12810.2548 },
            { x: 35278.9717, y: 12810.2548 },
            { x: 35278.9717, y: 4410.2548 },
            { x: 26878.9717, y: 4410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层南三区",
          name: "南3",
          sn: "B2-337",
          color: "rgba(0, 81, 255, 0)", icuId: '665dc016a3265241f4e9293f',
          point: [
            { x: 35878.9717, y: 12810.2548 },
            { x: 44278.9717, y: 12810.2548 },
            { x: 44278.9717, y: 4410.2548 },
            { x: 35878.9717, y: 4410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层南二区",
          name: "南2",
          sn: "B2-339",
          color: "rgba(0, 81, 255, 0)", icuId: '665d73be3185241b66ee6a21',
          point: [
            { x: 44878.9717, y: 12810.2548 },
            { x: 53278.9717, y: 12810.2548 },
            { x: 53278.9717, y: 4410.2548 },
            { x: 44878.9717, y: 4410.2548 },
          ],
        },
        {
          lig: 1,
          other: "B2三层南一区",
          name: "南1",
          sn: "B2-341",
          color: "rgba(0, 81, 255, 0)", icuId: '665d69113185241b66ee6951',
          point: [
            { x: 53878.9717, y: 12810.2548 },
            { x: 62278.9717, y: 12810.2548 },
            { x: 62278.9717, y: 4410.2548 },
            { x: 53878.9717, y: 4410.2548 },
          ],
        },
        {
          lig: 1,
          other: "323室",
          name: "323",
          sn: "B2-323",
          color: "rgba(0, 81, 255, 0)", icuId: '665ef0fba3265241f4e92d8d',
          point: [
            { x: 8478.9764, y: 32010.2563 },
            { x: 14478.9717, y: 32010.2563 },
            { x: 14478.9717, y: 25410.2563 },
            { x: 8478.9764, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "322室",
          name: "322",
          sn: "B2-322",
          color: "rgba(0, 81, 255, 0)", icuId: '',
          point: [
            { x: 14678.9717, y: 32010.2563 },
            { x: 20478.9717, y: 32010.2563 },
            { x: 20478.9717, y: 25410.2563 },
            { x: 14678.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "321室",
          name: "321",
          sn: "B2-321",
          color: "rgba(0, 81, 255, 0)", icuId: '665ef020a3265241f4e92d09',
          point: [
            { x: 20678.9717, y: 32010.2563 },
            { x: 26478.9717, y: 32010.2563 },
            { x: 26478.9717, y: 25410.2563 },
            { x: 20678.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "320室",
          name: "320",
          sn: "B2-320",
          color: "rgba(0, 81, 255, 0)", icuId: '665ee9b9a3265241f4e92cc7',
          point: [
            { x: 26678.9717, y: 32010.2563 },
            { x: 35478.9717, y: 32010.2563 },
            { x: 35478.9717, y: 25410.2563 },
            { x: 26678.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "319室",
          name: "319",
          sn: "B2-319",
          color: "rgba(0, 81, 255, 0)", icuId: '665ec0a3a3265241f4e92c99',
          point: [
            { x: 35678.9717, y: 32010.2563 },
            { x: 39978.9764, y: 32010.2563 },
            { x: 39978.9764, y: 25410.2563 },
            { x: 35678.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "318室",
          name: "318",
          sn: "B2-318",
          color: "rgba(0, 81, 255, 0)", icuId: '665ebedaa3265241f4e92c6b',
          point: [
            { x: 40178.9764, y: 32010.2563 },
            { x: 44478.9717, y: 32010.2563 },
            { x: 44478.9717, y: 25410.2563 },
            { x: 40178.9764, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "317室",
          name: "317",
          sn: "B2-317",
          color: "rgba(0, 81, 255, 0)", icuId: '665ebdf5a3265241f4e92c3d',
          point: [
            { x: 44678.9717, y: 32010.2563 },
            { x: 48978.9717, y: 32010.2563 },
            { x: 48978.9717, y: 25410.2563 },
            { x: 44678.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "316室",
          name: "316",
          sn: "B2-316",
          color: "rgba(0, 81, 255, 0)", icuId: '665ebcbaa3265241f4e92c0f',
          point: [
            { x: 49178.9717, y: 32010.2563 },
            { x: 53478.9717, y: 32010.2563 },
            { x: 53478.9717, y: 25410.2563 },
            { x: 49178.9717, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "315室",
          name: "315",
          sn: "B2-315",
          color: "rgba(0, 81, 255, 0)", icuId: '665ebb96a3265241f4e92be1',
          point: [
            { x: 53678.9717, y: 32010.2563 },
            { x: 57978.9741, y: 32010.2563 },
            { x: 57978.9741, y: 25410.2553 },
            { x: 53678.9717, y: 25410.2553 },
          ],
        },
        {
          lig: 1,
          other: "313室",
          name: "313",
          sn: "B2-313",
          color: "rgba(0, 81, 255, 0)", icuId: '665eb661a3265241f4e92bb3',
          point: [
            { x: 58178.9719, y: 32010.2563 },
            { x: 62478.9764, y: 32010.2563 },
            { x: 62478.9764, y: 25410.2563 },
            { x: 58178.9719, y: 25410.2563 },
          ],
        },
        {
          lig: 1,
          other: "312室",
          name: "312",
          sn: "B2-312",
          color: "rgba(0, 81, 255, 0)", icuId: '665eb237a3265241f4e92b85',
          point: [
            { x: 62678.9722, y: 32010.2563 },
            { x: 66978.9759, y: 32010.2563 },
            { x: 66978.9759, y: 25410.2551 },
            { x: 62678.9722, y: 25410.2551 },
          ],
        },
        {
          lig: 1,
          other: "311室",
          name: "311",
          sn: "B2-311",
          color: "rgba(0, 81, 255, 0)", icuId: '665eb11ca3265241f4e92b57',
          point: [
            { x: 67178.9764, y: 32010.2563 },
            { x: 71678.9764, y: 32010.2563 },
            { x: 71678.9764, y: 25410.2548 },
            { x: 67178.9764, y: 25410.2548 },
          ],
        },
        {
          lig: 1,
          other: "310室",
          name: "310",
          sn: "B2-310",
          color: "rgba(0, 81, 255, 0)", icuId: '',
          point: [
            { x: 68728.9759, y: 25210.2550 },
            { x: 71678.9764, y: 25210.2548 },
            { x: 71678.9764, y: 17385.2563 },
            { x: 67178.9759, y: 17385.2563 },
            { x: 67178.9759, y: 22210.2548 },
            { x: 68728.9759, y: 22210.2548 },
          ],
        },
        {
          lig: 1,
          other: "327室",
          name: "327",
          sn: "B2-325",
          color: "rgba(0, 81, 255, 0)",
          icuId: '665ef168a3265241f4e92dcf',
          point: [
            { x: 8678.9764, y: 19010.2561 },
            { x: 14378.9717, y: 19010.2561 },
            { x: 14378.9717, y: 13010.2558 },
            { x: 8678.9764, y: 13010.2558 },
          ],
        },
        {
          lig: 1,
          other: "326室",
          name: "326",
          sn: "B2-326",
          color: "rgba(0, 81, 255, 0)", icuId: '665ef1f2a3265241f4e92e11',
          point: [
            { x: 8678.9764, y: 25210.2563 },
            { x: 12878.9717, y: 25210.2563 },
            { x: 12878.9717, y: 22210.2548 },
            { x: 14378.9717, y: 22210.2548 },
            { x: 14378.9717, y: 19210.2561 },
            { x: 8678.9764, y: 19210.2561 },
          ],
        },],
      points4: [{
        lig: 1,
        other: "419室",
        name: "419",
        sn: "B2-423",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665ac3fb3185241b66ee634d',
        point: [
          { x: 8472.9219, y: 32606.9567 },
          { x: 17473.2730, y: 32606.9567 },
          { x: 17473.2730, y: 26369.1882 },
          { x: 8472.9219, y: 26369.1882 },
        ],
      },
      {
        lig: 1,
        other: "418室",
        name: "418",
        sn: "B2-422",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665877da5ad393313cfe9850',
        point: [
          { x: 17673.2730, y: 32606.9567 },
          { x: 21973.2730, y: 32606.9567 },
          { x: 21973.2730, y: 26369.1882 },
          { x: 17673.2730, y: 26369.1882 },
        ],
      },
      {
        lig: 1,
        other: "417室",
        name: "417",
        sn: "B2-421",
        color: "rgba(0, 81, 255, 0)",
        icuId: '6658727d5ad393313cfe9821',
        point: [
          { x: 22173.2730, y: 32606.9567 },
          { x: 26472.9171, y: 32606.9567 },
          { x: 26472.9171, y: 26369.1882 },
          { x: 22173.2730, y: 26369.1882 },
        ],
      },
      {
        lig: 1,
        other: "416室",
        name: "416",
        sn: "B2-420",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665abd3a3185241b66ee631f',
        point: [
          { x: 26672.9171, y: 32606.9567 },
          { x: 30972.8928, y: 32606.9567 },
          { x: 30972.8928, y: 26369.1872 },
          { x: 26672.9171, y: 26369.1872 },
        ],
      },
      {
        lig: 1,
        other: "415室",
        name: "415",
        sn: "B2-419",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665b0b4a3185241b66ee6497',
        point: [
          { x: 31172.8942, y: 32606.9567 },
          { x: 35472.8928, y: 32606.9567 },
          { x: 35472.8928, y: 26369.1862 },
          { x: 31172.8942, y: 26369.1862 },
        ],
      },
      {
        lig: 1,
        other: "413室",
        name: "413",
        sn: "B2-418",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665b055a3185241b66ee6455',
        point: [
          { x: 35672.8942, y: 32606.9567 },
          { x: 44472.8928, y: 32606.9567 },
          { x: 44472.8928, y: 26369.1843 },
          { x: 35672.8942, y: 26369.1843 },
        ],
      },
      {
        lig: 1,
        other: "412室",
        name: "412",
        sn: "B2-417",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665b029c3185241b66ee6413',
        point: [
          { x: 44672.8942, y: 32606.9567 },
          { x: 53472.9205, y: 32606.9567 },
          { x: 53472.9205, y: 26369.1823 },
          { x: 44672.8942, y: 26369.1882 },
        ],
      },
      {
        lig: 1,
        other: "实验室左",
        name: "实验室左",
        sn: "",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665afbfe3185241b66ee63d1',
        point: [
          { x: 44672.8942, y: 32606.9567 },
          { x: 53472.9205, y: 32606.9567 },
          { x: 53472.9205, y: 26369.1823 },
          { x: 44672.8942, y: 26369.1823 },
        ],
      },
      {
        lig: 1,
        other: "实验室",
        name: "实验室",
        sn: "B2-416",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665afbfe3185241b66ee63d1',
        point: [
          { x: 53672.9218, y: 32606.9567 },
          { x: 62472.8928, y: 32606.9567 },
          { x: 62472.8928, y: 26369.1803 },
          { x: 53672.9218, y: 26369.1803 },
        ],
      },

      {
        lig: 1,
        other: "409室",
        name: "409室",
        sn: "B2-409",
        color: "rgba(0, 81, 255, 0)",
        icuId: '',
        point: [
          { x: 67834.9293, y: 26169.1791 },
          { x: 71663.3287, y: 26169.1791 },
          { x: 71663.3287, y: 13602.6667 },
          { x: 67834.9293, y: 13602.6667 },
        ],
      },
      /*  {
         lig: 1,
         other: "421室",
         name: "421",
         sn: "B2-421",
         color: "rgba(0, 81, 255, 0)",
         icuId: '',
         point: [
           { x: 67172.9295, y: 7006.9567 },
           { x: 71472.9219, y: 7006.9567 },
           { x: 71472.9219, y: 4106.9554 },
           { x: 67172.9295, y: 4106.9554 },
         ],
       }, */
      {
        lig: 1,
        other: "403室",
        name: "403",
        sn: "B2-403",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665abaf13185241b66ee62f1',
        point: [
          { x: 13172.9219, y: 10906.9567 },
          { x: 17451.4764, y: 10906.9567 },
          { x: 17451.4764, y: 4106.9554 },
          { x: 13172.9219, y: 4106.9554 },
        ],
      },
      {
        lig: 1,
        other: "420室",
        name: "420",
        sn: "B2-426",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665879da5ad393313cfe987f',
        point: [
          { x: 8672.5148, y: 26169.1882 },
          { x: 15072.9171, y: 26169.1882 },
          { x: 15072.9171, y: 13606.9567 },
          { x: 8672.5148, y: 13606.9567 },
        ],
      },
      {
        lig: 1,
        other: "B2四层北五区",
        name: "BW_NO11",
        sn: "B2-432",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c90f43185241b66ee6646',
        point: [
          { x: 17872.9171, y: 22406.9552 },
          { x: 26272.9171, y: 22406.9552 },
          { x: 26272.9171, y: 14006.9552 },
          { x: 17872.9171, y: 14006.9552 },
        ],
      },
      {
        lig: 1,
        other: "B2四层北四区",
        name: "BW_NO14",
        sn: "B2-434",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91073185241b66ee6688',
        point: [
          { x: 26872.9171, y: 22406.9552 },
          { x: 35272.9095, y: 22406.9552 },
          { x: 35272.9095, y: 14006.9522 },
          { x: 26872.9171, y: 14006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层北三区",
        name: "BW_NO2",
        sn: "B2-436",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91383185241b66ee6758',
        point: [
          { x: 35872.9171, y: 22406.9552 },
          { x: 44272.9171, y: 22406.9552 },
          { x: 44272.9171, y: 14006.9522 },
          { x: 35872.9171, y: 14006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层北二区",
        name: "BW_NO9",
        sn: "B2-438",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91803185241b66ee6800',
        point: [
          { x: 44872.9171, y: 22406.9552 },
          { x: 53272.9171, y: 22406.9552 },
          { x: 53272.9171, y: 14006.9552 },
          { x: 44872.9171, y: 14006.9552 },
        ],
      },
      {
        lig: 1,
        other: "B2四层北一区",
        name: "BW_NO12",
        sn: "B2-440",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91c33185241b66ee68a8',
        point: [
          { x: 53872.9171, y: 22406.9552 },
          { x: 62272.9095, y: 22406.9552 },
          { x: 62272.9095, y: 14006.9522 },
          { x: 53872.9171, y: 14006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层南一区",
        name: "BW_NO1",
        sn: "B2-441",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91d63185241b66ee6910',
        point: [
          { x: 53872.9171, y: 13406.9552 },
          { x: 62272.9171, y: 13406.9552 },
          { x: 62272.9171, y: 5006.9522 },
          { x: 53872.9171, y: 5006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层南二区",
        name: "BW_NO10",
        sn: "B2-439",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91a13185241b66ee6868',
        point: [
          { x: 44872.9171, y: 13406.9552 },
          { x: 53272.9171, y: 13406.9552 },
          { x: 53272.9171, y: 5006.9522 },
          { x: 44872.9171, y: 5006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层南三区",
        name: "BW_NO16",
        sn: "B2-437",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91593185241b66ee67c0',
        point: [
          { x: 35872.9171, y: 13406.9552 },
          { x: 44272.9171, y: 13406.9552 },
          { x: 44272.9171, y: 5006.9522 },
          { x: 35872.9171, y: 5006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层南四区",
        name: "BW_NO15",
        sn: "B2-435",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c91233185241b66ee66f0',
        point: [
          { x: 26872.9171, y: 13406.9552 },
          { x: 35272.9171, y: 13406.9552 },
          { x: 35272.9171, y: 5006.9522 },
          { x: 26872.9171, y: 5006.9522 },
        ],
      },
      {
        lig: 1,
        other: "B2四层南五区",
        name: "BW_NO13",
        sn: "B2-433",
        color: "rgba(0, 81, 255, 0)",
        icuId: '665c90f43185241b66ee6646',
        point: [
          { x: 17872.9171, y: 13406.9567 },
          { x: 26272.9171, y: 13406.9567 },
          { x: 26272.9171, y: 5006.9552 },
          { x: 17872.9171, y: 5006.9552 },
        ],
      }],
      points5: [
        {
          lig: 1,
          other: "北五区",
          name: 'BW_NO1',
          sn: "B2-532",
          icuId: '664f4a4edb111b252056d5a1',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 26169.8687, y: 20982.4732 },
            { x: 17889.7943, y: 20982.4747 },
            { x: 17889.8687, y: 13786.4821 },
            { x: 26169.8687, y: 13786.4732 },
          ]
        },
        {
          lig: 1,
          other: "北四区",
          name: 'BW_NO2',
          sn: "B2-534",
          icuId: '664f4f7ddb111b252056d608',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 26989.868748, y: 20982.475072 },
            { x: 26989.868748, y: 13786.473546 },
            { x: 35169.868748, y: 13786.473546 },
            { x: 35169.868748, y: 20982.475072 },
          ]
        }, {
          lig: 1,
          other: "北三区",
          name: 'BW_NO16',
          sn: "B2-536",
          icuId: '664f5364db111b252056d66f',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 35989.7943, y: 20982.4751 },
            { x: 44169.7943, y: 20982.4751 },
            { x: 44169.7943, y: 13786.4735 },
            { x: 35989.7943, y: 13786.4735 },
          ]
        }, {
          lig: 1,
          other: "北二区",
          name: 'BW_NO9',
          sn: "B2-538",
          icuId: '664f546bdb111b252056d6d6',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 44989.8687, y: 20982.4751 },
            { x: 53169.8687, y: 20982.4751 },
            { x: 53169.8687, y: 13786.4735 },
            { x: 44989.8687, y: 13786.4735 },
          ]
        }, {
          lig: 1,
          other: "北一区",
          name: 'BW_NO12',
          sn: "B2-540",
          color: "rgba(0, 81, 255, 0)",
          icuId: '664b36c0db111b252056d2d5',
          point: [
            { x: 53989.7943, y: 20982.4751 },
            { x: 62879.8687, y: 20982.4751 },
            { x: 62879.8687, y: 13786.4735 },
            { x: 53989.7943, y: 13786.4735 },
          ]
        }, {
          lig: 1,
          other: "南五区",
          name: 'BW_NO13',
          sn: "B2-533",
          color: "rgba(0, 81, 255, 0)",
          icuId: '664e21a4db111b252056d480',
          point: [
            { x: 17889.7943, y: 11607.4732 },
            { x: 26169.8687, y: 11607.4732 },
            { x: 26169.8687, y: 4411.4732 },
            { x: 17889.7943, y: 4411.4732 },

          ]
        }, {
          lig: 1,
          other: "南四区",
          name: 'BW_NO14',
          sn: "B2-535",
          color: "rgba(0, 81, 255, 0)",
          icuId: '664e21ebdb111b252056d4bf',
          point: [
            { x: 26989.8687, y: 11607.4732 },
            { x: 35169.8687, y: 11607.4732 },
            { x: 35169.8687, y: 4411.4732 },
            { x: 26989.8687, y: 4411.4732 },

          ]
        }, {
          lig: 1,
          other: "南三区",
          name: 'BW_NO15',
          sn: "B2-537",
          color: "rgba(0, 81, 255, 0)",
          icuId: '664f56d4db111b252056d7a4',
          point: [
            { x: 35989.7943, y: 11607.4732 },
            { x: 44169.7943, y: 11607.4732 },
            { x: 44169.7943, y: 4411.4732 },
            { x: 35989.7943, y: 4411.4732 },
          ]
        }, {
          lig: 1,
          other: "南二区",
          name: 'BW_NO10',
          sn: "B2-539",
          color: "rgba(0, 81, 255, 0)",
          icuId: '664e1d98db111b252056d441',
          point: [
            { x: 44989.8687, y: 11607.4732 },
            { x: 53169.8687, y: 11607.4732 },
            { x: 53169.8687, y: 4411.4732 },
            { x: 44989.8687, y: 4411.4732 },
          ]
        }, {
          lig: 1,
          other: "南一区",
          name: 'BW_NO11',
          sn: "B2-541",
          icuId: '664ccb24db111b252056d402',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 53989.7943, y: 11607.4732 },
            { x: 62479.8065, y: 11607.4732 },
            { x: 62479.8065, y: 4411.4732 },
            { x: 53989.7943, y: 4411.4732 },

          ]
        }, {
          lig: 2,
          other: "523室",
          name: '523',
          sn: "B2-523",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652da53db111b252056da74',
          point: [
            { x: 8679.8735, y: 31411.4791 },
            { x: 8679.8735, y: 25411.4821 },
            { x: 17479.8735, y: 25411.4821 },
            { x: 17479.8735, y: 31411.4791 },
          ]
        }, {
          lig: 1,
          other: "522室",
          name: '522',
          sn: "B2-522",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652d68adb111b252056d9f1',
          point: [
            { x: 17679.8735, y: 31411.4791 },
            { x: 21979.8735, y: 31411.4791 },
            { x: 21979.8735, y: 25411.4821 },
            { x: 17679.8735, y: 25411.4821 },

          ]
        }, {
          lig: 1,
          other: "521室",
          name: '521',
          sn: "B2-521",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652d44cdb111b252056d9c4',
          point: [
            { x: 22179.8735, y: 31411.4791 },
            { x: 26479.8735, y: 31411.4791 },
            { x: 26479.8735, y: 25411.4821 },
            { x: 22179.8735, y: 25411.4821 },
          ]
        }, {
          lig: 2,
          other: "519室",
          name: '519',
          sn: "B2-519",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6655c63b5ad393313cfe9328',
          point: [
            { x: 29679.8735, y: 31411.4791 },
            { x: 35479.8687, y: 31411.4791 },
            { x: 35479.8687, y: 25411.4821 },
            { x: 29679.8735, y: 25411.4821 },
          ]
        }, {
          lig: 1,
          other: "518室",
          name: '518',
          sn: "B2-518",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652d1a0db111b252056d997',
          point: [
            { x: 35679.8687, y: 31411.4791 },
            { x: 39979.8735, y: 31411.4791 },
            { x: 39979.8735, y: 25411.4821 },
            { x: 35679.8687, y: 25411.4821 },
          ]
        }, {
          lig: 1,
          other: "517室",
          name: '517',
          sn: "B2-517",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652cfe7db111b252056d96a',
          point: [
            { x: 40179.8735, y: 31411.4791 },
            { x: 44479.8735, y: 31411.4791 },
            { x: 44479.8735, y: 25411.4821 },
            { x: 40179.8735, y: 25411.4821 },
          ]
        }, {
          lig: 1,
          other: "516室",
          name: '516',
          sn: "B2-516",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652cf5bdb111b252056d93d',
          point: [
            { x: 44679.8735, y: 31411.4791 },
            { x: 48979.8735, y: 31411.4791 },
            { x: 48979.8735, y: 25411.4821 },
            { x: 44679.8735, y: 25411.4821 },
          ]
        }, {
          lig: 2,
          other: "515室",
          name: '515',
          sn: "B2-515",
          color: "rgba(0, 81, 255, 0)",
          icuId: '66537c27db111b252056dbca',
          point: [
            { x: 49179.8735, y: 31411.4791 },
            { x: 53479.8735, y: 31411.4791 },
            { x: 53479.8735, y: 25411.4821 },
            { x: 49179.8735, y: 25411.4821 },
          ]
        }, {
          lig: 1,
          other: "513室",
          name: '513',
          sn: "B2-513",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6651cac6db111b252056d8b4',
          point: [
            { x: 53679.8735, y: 31411.4791 },
            { x: 57979.8735, y: 31411.4791 },
            { x: 57979.8735, y: 25411.4821 },
            { x: 53679.8735, y: 25411.4821 },

          ]
        }, {
          lig: 2,
          other: "512室",
          name: '512',
          sn: "B2-512",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6651f146db111b252056d8e1',
          point: [
            { x: 58179.8735, y: 31411.4791 },
            { x: 62479.8736, y: 31411.4791 },
            { x: 62479.8736, y: 25411.4821 },
            { x: 58179.8735, y: 25411.4821 },

          ]
        }, {
          lig: 2,
          other: "511室",
          name: '511',
          sn: "B2-511",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6651f2a6db111b252056d90e',
          point: [
            { x: 62679.8735, y: 31411.4791 },
            { x: 66979.8735, y: 31411.4791 },
            { x: 66979.8735, y: 25411.4821 },
            { x: 62679.8735, y: 25411.4821 },
          ]
        }, {
          lig: 2,
          other: "510室",
          name: '510',
          sn: "B2-510",
          color: "rgba(0, 81, 255, 0)",
          icuId: '665057c1db111b252056d7f4',
          point: [
            { x: 67179.8735, y: 32211.4821 },
            { x: 71679.8735, y: 32211.4821 },
            { x: 71679.8735, y: 21751.4806 },
            { x: 67179.8735, y: 21751.4806 },

          ]
        }, {
          lig: 2,
          other: "509室",
          name: '509',
          sn: "B2-509",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6651c4a6db111b252056d872',
          point: [
            { x: 67179.8735, y: 21351.4806 },
            { x: 71679.8735, y: 21351.4806 },
            { x: 71679.8735, y: 13011.4821 },
            { x: 67179.8735, y: 13011.4821 },
          ]
        }, {
          lig: 2,
          other: "526室",
          name: '526',
          sn: "B2-526",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652d841db111b252056da1e',
          point: [
            { x: 8679.8735, y: 25211.4808 },
            { x: 15054.8687, y: 25211.4808 },
            { x: 15054.8687, y: 13011.4821 },
            { x: 8679.8735, y: 13011.4821 },
          ]
        }, {
          lig: 1,
          other: "529室",
          name: '529',
          sn: "B2-529",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652d841db111b252056da1e',
          point: [
            { x: 219.8735, y: 25611.4821 },
            { x: 5279.8735, y: 25611.4821 },
            { x: 5279.8735, y: 20761.4785 },
            { x: 219.8735, y: 20761.4785 },

          ]
        }, {
          lig: 1,
          other: "503室",
          name: '503',
          sn: "B2-503",
          color: "rgba(0, 81, 255, 0)",
          icuId: '6652dde4db111b252056dab6',
          point: [
            { x: 13179.8735, y: 10311.4821 },
            { x: 17279.8687, y: 10311.4821 },
            { x: 17279.8687, y: 3311.4821 },
            { x: 13179.8735, y: 3311.4821 },
          ]
        }, {
          lig: 1,
          other: "空调机房",
          name: '544风机盘管数据接口',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 8679.8735, y: 10311.4821 },
            { x: 12979.8735, y: 10311.4821 },
            { x: 12979.8735, y: 3311.4821 },
            { x: 8679.8735, y: 3311.4821 },
          ]
        }, {
          lig: 1,
          other: "空调机房",
          name: '543风机盘管数据接口',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 62679.8810, y: 10311.4821 },
            { x: 66979.8811, y: 10311.4821 },
            { x: 66979.8811, y: 3311.4821 },
            { x: 62679.8810, y: 3311.4821 },
          ]
        }, /* {
          lig: 1,
          other: "弱电间",
          name: '弱电间',
          sn: "",
          icuId: '',
          color: "rgba(0, 81, 255, 0)",
          point: [
            { x: 67179.8811, y: 10311.4821 },
            { x: 69479.8811, y: 10311.4821 },
            { x: 69479.8811, y: 6611.4821 },
            { x: 67179.8811, y: 6611.4821 },
          ]
        }, {
          lig: 1,
          other: "强电间",
          name: '强电间',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 69679.8811, y: 10311.4821 },
            { x: 71679.8810, y: 10311.4821 },
            { x: 71679.8810, y: 6611.4821 },
            { x: 69679.8811, y: 6611.4821 },
          ]
        }, {
          lig: 1,
          other: "储藏室",
          name: '储藏室',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 67179.8811, y: 6411.4821 },
            { x: 67179.8811, y: 6611.4821 },
            { x: 71679.8810, y: 6411.4821 },
            { x: 71679.8810, y: 6611.4821 },

          ]
        }, {
          lig: 1,
          other: "电梯厅",
          name: '电梯厅',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 71879.8810, y: 12811.4852 },
            { x: 77579.8735, y: 12811.4852 },
            { x: 77579.8735, y: 4161.4821 },
            { x: 71879.8810, y: 4161.4821 },
          ]
        }, {
          lig: 1,
          other: "茶水间",
          name: '茶水间',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 72679.8735, y: 17461.0865 },
            { x: 75079.8735, y: 17461.0865 },
            { x: 75079.8735, y: 13011.4821 },
            { x: 72679.8735, y: 13011.4821 },
          ]
        },
        {
          lig: 1,
          other: "卫生间",
          name: '卫生间',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 71909.8735, y: 25581.4821 },
            { x: 71909.8735, y: 21321.4806 },
            { x: 73109.8735, y: 21351.4806 },
            { x: 73109.8735, y: 20541.4826 },
            { x: 75049.8737, y: 20541.4826 },
            { x: 75049.8737, y: 22141.4826 },
            { x: 77509.8737, y: 22141.4826 },
            { x: 77509.8737, y: 20541.4806 },
            { x: 80249.8735, y: 20541.4806 },
            { x: 80679.8661, y: 20941.4806 },
            { x: 80679.8661, y: 25181.4806 },
            { x: 80249.8565, y: 25181.4806 },
            { x: 80249.8565, y: 25581.4821 },
          ]
        }, {
          lig: 1,
          other: "电梯厅",
          name: '电梯厅',
          sn: "",
          color: "rgba(0, 81, 255, 0)",
          icuId: '',
          point: [
            { x: 219.8735, y: 20561.4786 },
            { x: 219.8735, y: 4511.4806 },
            { x: 8479.8735, y: 4511.4806 },
            { x: 8479.8735, y: 12811.4821 },
            { x: 5279.4664, y: 12811.4821 },
            { x: 5279.4664, y: 20561.4785 },
          ]
        }, */
        {
          lig: 1,
          other: "门锁",
          name: '右侧门锁',
          sn: "",
          color: "rgba(0, 81, 255, 0.9)",
          icuId: '',
          point: [
            { x: 70613.03976190506, y: 12343.77088027267 },
            { x: 72622.40844450286, y: 12343.77088027267 },
            { x: 70613.03976190506, y: 10525.64502731021 },
            { x: 72622.40844450286, y: 10525.64502731021 },
          ]
        },

      ],
      symbols: null, // 文字
      geoDatas: [],// 承接文字
      textPoint: [
        {
          id: 0,
          point: { x: 22030.386754491883, y: 17242.019131448906 },
          color: '#ffffff',
          text: 'N5: ',
          sn: 'B2-532',
          value: '25.0℃',
        },
        {
          id: 1,
          point: { x: 31079.212287917406, y: 17109.597294374355 },
          color: '#ffffff',
          text: 'N4:  ',
          sn: 'B2-534',
          value: '25.0℃',
        },
        {
          id: 2,
          point: { x: 40057.788935966244, y: 17113.743116480444 },
          color: '#ffffff',
          text: 'N3:  ',
          sn: 'B2-536',
          value: '25.0℃',
        },
        {
          id: 3,
          point: { x: 49082.05039682121, y: 17247.12747320994 },
          color: '#ffffff',
          text: 'N2:  ',
          sn: 'B2-538',
          value: '25.0℃',
        }
        ,
        {
          id: 4,
          point: { x: 58062.952349014486, y: 17247.12747320994 },
          color: '#ffffff',
          text: 'N1:  ',
          sn: 'B2-540',
          value: '25.0℃',
        }
        ,
        {
          id: 5,
          point: { x: 22049.982331762316, y: 7864.095582858645 },
          color: '#ffffff',
          text: 'S5:  ',
          sn: 'B2-533',
          value: '25.0℃',
        }
        ,
        {
          id: 6,
          point: { x: 31075.565388195108, y: 7864.095582858645 },
          color: '#ffffff',
          text: 'S4:  ',
          sn: 'B2-535',
          value: '25.0℃',
        },
        {
          id: 7,
          point: { x: 40101.148444627914, y: 7864.095582858645 },
          color: '#ffffff',
          text: 'S3:  ',
          sn: 'B2-537',
          value: '25.0℃',
        },
        {
          id: 8,
          point: { x: 49082.05039682121, y: 7864.095582858645 },
          color: '#ffffff',
          text: 'S2:  ',
          sn: 'B2-539',
          value: '25.0℃',
        },
        {
          id: 9,
          point: { x: 58018.27124477419, y: 7864.095582858645 },
          color: '#ffffff',
          text: 'S1:  ',
          sn: 'B2-541',
          value: '25.0℃',
        },
        {
          id: 523,
          point: { x: 12964.46368083654, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-523',
          value: '25.0℃',
        },
        {
          id: 522,
          point: { x: 19802.015449641993, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-522',
          value: '25.0℃',
        },
        {
          id: 521,
          point: { x: 24394.786071707356, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-521',
          value: '25.0℃',
        },
        {
          id: 519,
          point: { x: 32470.800967240742, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-519',
          value: '25.0℃',
        },
        {
          id: 518,
          point: { x: 37781.546408572955, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-518',
          value: '25.0℃',
        },
        {
          id: 517,
          point: { x: 42245.30661990644, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-517',
          value: '25.0℃',
        },
        {
          id: 516,
          point: { x: 46760.67099553292, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-516',
          value: '25.0℃',
        },
        {
          id: 515,
          point: { x: 51250.24643478085, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-515',
          value: '25.0℃',
        },
        {
          id: 513,
          point: { x: 55739.80872826106, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-513',
          value: '25.0℃',
        },
        {
          id: 512,
          point: { x: 60332.56003228618, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-512',
          value: '25.0℃',
        },
        {
          id: 511,
          point: { x: 65028.51856819551, y: 28893.69073128405 },
          color: '#ffffff',
          text: '',
          sn: 'B2-511',
          value: '25.0℃',
        },
        {
          id: 510,
          point: { x: 69440.61553437158, y: 27052.67851158831 },
          color: '#ffffff',
          text: '',
          sn: 'B2-510',
          value: '25.0℃',
        },
        {
          id: 509,
          point: { x: 69440.61553437158, y: 17299.49358656 },
          color: '#ffffff',
          text: '',
          sn: 'B2-509',
          value: '25.0℃',
        },
        {
          id: 526,
          point: { x: 11801.181192027325, y: 19086.15860042993 },
          color: '#ffffff',
          text: '',
          sn: 'B2-526',
          value: '25.0℃',
        }, {
          id: 503,
          point: { x: 15147.704825983783, y: 6891.645341142561 },
          color: '#ffffff',
          text: '',
          sn: 'B2-503',
          value: '25.0℃',
        },
        /* {
          id: 5001,
          point: { x: 68304.9289714107, y: 7492.864644488785 },
          color: '#ffffff',
          text: '',
          sn: '5',
          value: '25.0℃',
        } */


      ], // 文字坐标
      textPoint5: [{
        id: 0,
        point: { x: 22030.386754491883, y: 17242.019131448906 },
        color: '#ffffff',
        text: 'N5: ',
        sn: 'B2-532',
        value: '25.0℃',
      },
      {
        id: 1,
        point: { x: 31079.212287917406, y: 17109.597294374355 },
        color: '#ffffff',
        text: 'N4:  ',
        sn: 'B2-534',
        value: '25.0℃',
      },
      {
        id: 2,
        point: { x: 40057.788935966244, y: 17113.743116480444 },
        color: '#ffffff',
        text: 'N3:  ',
        sn: 'B2-536',
        value: '25.0℃',
      },
      {
        id: 3,
        point: { x: 49082.05039682121, y: 17247.12747320994 },
        color: '#ffffff',
        text: 'N2:  ',
        sn: 'B2-538',
        value: '25.0℃',
      }
        ,
      {
        id: 4,
        point: { x: 58062.952349014486, y: 17247.12747320994 },
        color: '#ffffff',
        text: 'N1:  ',
        sn: 'B2-540',
        value: '25.0℃',
      }
        ,
      {
        id: 5,
        point: { x: 22049.982331762316, y: 7864.095582858645 },
        color: '#ffffff',
        text: 'S5:  ',
        sn: 'B2-533',
        value: '25.0℃',
      }
        ,
      {
        id: 6,
        point: { x: 31075.565388195108, y: 7864.095582858645 },
        color: '#ffffff',
        text: 'S4:  ',
        sn: 'B2-535',
        value: '25.0℃',
      },
      {
        id: 7,
        point: { x: 40101.148444627914, y: 7864.095582858645 },
        color: '#ffffff',
        text: 'S3:  ',
        sn: 'B2-537',
        value: '25.0℃',
      },
      {
        id: 8,
        point: { x: 49082.05039682121, y: 7864.095582858645 },
        color: '#ffffff',
        text: 'S2:  ',
        sn: 'B2-539',
        value: '25.0℃',
      },
      {
        id: 9,
        point: { x: 58018.27124477419, y: 7864.095582858645 },
        color: '#ffffff',
        text: 'S1:  ',
        sn: 'B2-541',
        value: '25.0℃',
      },
      {
        id: 523,
        point: { x: 12964.46368083654, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-523',
        value: '25.0℃',
      },
      {
        id: 522,
        point: { x: 19802.015449641993, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-522',
        value: '25.0℃',
      },
      {
        id: 521,
        point: { x: 24394.786071707356, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-521',
        value: '25.0℃',
      },
      {
        id: 519,
        point: { x: 32470.800967240742, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-519',
        value: '25.0℃',
      },
      {
        id: 518,
        point: { x: 37781.546408572955, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-518',
        value: '25.0℃',
      },
      {
        id: 517,
        point: { x: 42245.30661990644, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-517',
        value: '25.0℃',
      },
      {
        id: 516,
        point: { x: 46760.67099553292, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-516',
        value: '25.0℃',
      },
      {
        id: 515,
        point: { x: 51250.24643478085, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-515',
        value: '25.0℃',
      },
      {
        id: 513,
        point: { x: 55739.80872826106, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-513',
        value: '25.0℃',
      },
      {
        id: 512,
        point: { x: 60332.56003228618, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-512',
        value: '25.0℃',
      },
      {
        id: 511,
        point: { x: 65028.51856819551, y: 28893.69073128405 },
        color: '#ffffff',
        text: '',
        sn: 'B2-511',
        value: '25.0℃',
      },
      {
        id: 510,
        point: { x: 69440.61553437158, y: 27052.67851158831 },
        color: '#ffffff',
        text: '',
        sn: 'B2-510',
        value: '25.0℃',
      },
      {
        id: 509,
        point: { x: 69440.61553437158, y: 17299.49358656 },
        color: '#ffffff',
        text: '',
        sn: 'B2-509',
        value: '25.0℃',
      },
      {
        id: 526,
        point: { x: 11801.181192027325, y: 19086.15860042993 },
        color: '#ffffff',
        text: '',
        sn: 'B2-526',
        value: '25.0℃',
      }, {
        id: 503,
        point: { x: 15147.704825983783, y: 6891.645341142561 },
        color: '#ffffff',
        text: '',
        sn: 'B2-503',
        value: '25.0℃',
      },
      ],
      textPoint4: [{
        id: 419,
        point: { x: 12629.282624422718, y: 29459.613541524945 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-423",
        value: "26.0℃",
      },
      {
        id: 418,
        point: { x: 19944.59160893556, y: 29538.33920882581 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-422",
        value: "26.0℃",
      },
      {
        id: 417,
        point: { x: 24144.063577676512, y: 29538.43036766557 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-421",
        value: "26.0℃",
      },
      {
        id: 416,
        point: { x: 28731.029846899197, y: 29538.357310251507 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-420",
        value: "26.0℃",
      },
      {
        id: 415,
        point: { x: 33253.16161184285, y: 29538.956965085687 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-419",
        value: "26.0℃",
      },
      {
        id: 413,
        point: { x: 40054.59175325003, y: 29538.358725124737 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-418",
        value: "26.0℃",
      },
      {
        id: 417,
        point: { x: 48958.72150584438, y: 29538.027102165433 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-417",
        value: "26.0℃",
      },

      {
        id: 400,
        point: { x: 57964.302494989446, y: 29538.961357525375 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-416",
        value: "26.0℃",
      },
      // {
      //   id: 410,
      //   point: { x: 67286.53002771793, y: 29598.904801063385 },
      //   color: "#c0c0c0",
      //   text: "B9:",
      //   sn: "",
      //   value: "26.0℃",
      // },
      // {
      //   id: 409,
      //   point: { x: 69782.54944580111, y: 20004.018093532737 },
      //   color: "#c0c0c0",
      //   text: "B10:",
      //   sn: "",
      //   value: "26.0℃",
      // },
      // {
      //   id: 1,
      //   point: { x: 70700.95050884756, y: 8931.513221349596 },
      //   color: "#c0c0c0",
      //   text: "强电间：",
      //   sn: "",
      //   value: "26.0℃",
      // },
      // {
      //   id: 2,
      //   point: { x: 70648.99547734101, y: 8931.513221349596 },
      //   color: "#c0c0c0",
      //   text: "弱电间：",
      //   sn: "",
      //   value: "26.0℃",
      // },
      // {
      //   id: 3,
      //   point: { x: 64983.297507713985, y: 7185.514152718126 },
      //   color: "#c0c0c0",
      //   text: "右空调机房：",
      //   sn: "",
      //   value: "26.0℃",
      // },
      /* {
        id: 421,
        point: { x: 69294.12801333061, y: 5465.468806927005 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-421",
        value: "26.0℃",
      }, */
      {
        id: 403,
        point: { x: 15233.07991919246, y: 7372.65192914754155 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-403",
        value: "26.0℃",
      },
      {
        id: 4,
        point: { x: 10827.813281781244, y: 7119.854528792173 },
        color: "#c0c0c0",
        text: "",
        sn: "",
        value: "26.0℃",
      },
      {
        id: 420,
        point: { x: 11918.452557980854, y: 19846.247486910797 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-426",
        value: "26.0℃",
      },
      {
        id: 432,
        point: { x: 22068.42879807776, y: 17667.25685335844 },
        color: "#c0c0c0",
        text: "N5:",
        sn: "B2-432",
        value: "26.0℃",
      },
      {
        id: 434,
        point: { x: 31154.781980846587, y: 17667.450154499355 },
        color: "#c0c0c0",
        text: "N4:",
        sn: "B2-434",
        value: "26.0℃",
      },
      {
        id: 436,
        point: { x: 40116.9473491933, y: 17744.20146682908 },
        color: "#c0c0c0",
        text: "N3:",
        sn: "B2-436",
        value: "26.0℃",
      },
      {
        id: 438,
        point: { x: 49174.618019662696, y: 17704.53786264418 },
        color: "#c0c0c0",
        text: "N2:",
        sn: "B2-438",
        value: "26.0℃",
      },
      {
        id: 440,
        point: { x: 58169.647317370254, y: 17628.16648178079 },
        color: "#c0c0c0",
        text: "N1:",
        sn: "B2-440",
        value: "26.0℃",
      },
      {
        id: 433,
        point: { x: 22180.581399138653, y: 8633.229560264605 },
        color: "#c0c0c0",
        text: "S5:",
        sn: "B2-433",
        value: "26.0℃",
      },
      {
        id: 435,
        point: { x: 31158.399261616534, y: 8633.577462861183 },
        color: "#c0c0c0",
        text: "S4:",
        sn: "B2-435",
        value: "26.0℃",
      },
      {
        id: 437,
        point: { x: 40085.9685075163, y: 8633.577462861183 },
        color: "#c0c0c0",
        text: "S3:",
        sn: "B2-437",
        value: "26.0℃",
      },
      {
        id: 439,
        point: { x: 49160.9505373039, y: 8633.760131557094 },
        color: "#c0c0c0",
        text: "S2:",
        sn: "B2-439",
        value: "26.0℃",
      },
      {
        id: 441,
        point: { x: 58155.28130868361, y: 8633.307719620978 },
        color: "#c0c0c0",
        text: "S1:",
        sn: "B2-441",
        value: "26.0℃",
      },],
      textPoint3: [
        {
          id: 318,
          point: { x: 42264.52136032625, y: 28881.463392225 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-318",
          value: "26.0℃",
        }, {
          id: 323,
          point: { x: 11514.747725173118, y: 28881.541495574667 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-323",
          value: "26.0℃",
        },
        {
          id: 322,
          point: { x: 17579.05296288854, y: 28881.3924172892 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-322",
          value: "26.0℃",
        },
        {
          id: 321,
          point: { x: 23507.12737308943, y: 28881.388989617393 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-321",
          value: "26.0℃",
        },
        {
          id: 320,
          point: { x: 30988.54181500677, y: 28881.60552287189 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-320",
          value: "26.0℃",
        },
        {
          id: 319,
          point: { x: 37904.57783085079, y: 28881.46339222 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-319",
          value: "26.0℃",
        },
        {
          id: 317,
          point: { x: 46720.32744674722, y: 28881.809736309297 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-317",
          value: "26.0℃",
        },
        {
          id: 316,
          point: { x: 51158.70728350083, y: 28881.431702670932 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-316",
          value: "26.0℃",
        },
        {
          id: 315,
          point: { x: 55582.778046667605, y: 28881.833850405354 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-315",
          value: "26.0℃",
        },
        {
          id: 313,
          point: { x: 60309.92001710519, y: 28881.039138382897 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-313",
          value: "26.0℃",
        },
        {
          id: 312,
          point: { x: 64805.13297314114, y: 28881.24708251188 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-312",
          value: "26.0℃",
        },
        {
          id: 311,
          point: { x: 69349.52296135513, y: 28881.793335993454 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-311",
          value: "26.0℃",
        },
        {
          id: 310,
          point: { x: 69604.57552267719, y: 20970.187025997046 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-310",
          value: "26.0℃",
        },
        // {
        //   id: 1,
        //   point: { x: 70671.50053954677, y: 8346.525591430574 },
        //   color: "#c0c0c0",
        //   text: "强电间:",
        //   sn: "",
        //   value: "26.0℃",
        // },
        // {
        //   id: 2,
        //   point: { x: 68294.82322966587, y: 8346.167721937032 },
        //   color: "#c0c0c0",
        //   text: "弱电间:",
        //   sn: "",
        //   value: "26.0℃",
        // },
        // {
        //   id: 3,
        //   point: { x: 64829.20723590317, y: 6757.8429758029815 },
        //   color: "#c0c0c0",
        //   text: "空调机房右:",
        //   sn: "",
        //   value: "26.0℃",
        // },
        // {
        //   id: 4,
        //   point: { x: 10773.033120094842, y: 6585.47133278774 },
        //   color: "#c0c0c0",
        //   text: "空调机房左:",
        //   sn: "",
        //   value: "26.0℃",
        // },
        {
          id: 327,
          point: { x: 11352.162271398498, y: 16155.927411142897 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-325",
          value: "26.0℃",
        },
        {
          id: 326,
          point: { x: 11185.135699923369, y: 22099.8492945373 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-326",
          value: "26.0℃",
        },
        {
          id: 332,
          point: { x: 21906.67864124292, y: 17287.84243005974 },
          color: "#c0c0c0",
          text: "N5: ",
          sn: "B2-332",
          value: "26.0℃",
        },
        {
          id: 334,
          point: { x: 31070.299771032645, y: 17287.988745472045 },
          color: "#c0c0c0",
          text: "N4: ",
          sn: "B2-334",
          value: "26.0℃",
        },
        {
          id: 336,
          point: { x: 40093.00098686674, y: 17287.22801249902 },
          color: "#c0c0c0",
          text: "N3: ",
          sn: "B2-336",
          value: "26.0℃",
        },
        {
          id: 338,
          point: { x: 49055.00334930289, y: 17287.84024304732 },
          color: "#c0c0c0",
          text: "N2: ",
          sn: "B2-338",
          value: "26.0℃",
        },
        {
          id: 340,
          point: { x: 58044.90493308268, y: 17287.29209624749 },
          color: "#c0c0c0",
          text: "N1: ",
          sn: "B2-340",
          value: "26.0℃",
        },
        {
          id: 333,
          point: { x: 22055.50296227762, y: 8422.037638395443 },
          color: "#c0c0c0",
          text: "S5: ",
          sn: "B2-333",
          value: "26.0℃",
        },
        {
          id: 335,
          point: { x: 31067.086012701024, y: 8422.453792788423 },
          color: "#c0c0c0",
          text: "S4: ",
          sn: "B2-335",
          value: "26.0℃",
        },
        {
          id: 337,
          point: { x: 40105.8602030771, y: 8422.35836820041 },
          color: "#c0c0c0",
          text: "S3: ",
          sn: "B2-337",
          value: "26.0℃",
        },
        {
          id: 339,
          point: { x: 49023.216872475256, y: 8422.617591072849 },
          color: "#c0c0c0",
          text: "S2: ",
          sn: "B2-339",
          value: "26.0℃",
        },
        {
          id: 341,
          point: { x: 58710.90745004575, y: 8422.777421255232 },
          color: "#c0c0c0",
          text: "S1: ",
          sn: "B2-341",
          value: "26.0℃",
        },],
      textPoint2: [
        {
          id: 213,
          point: { x: 110425.6061, y: 37709.654240384 },
          color: "#c0c0c0",
          text: "213：",
          sn: "B2-211",
          value: "26.0℃",
        },
        {
          id: 215,
          point: { x: 110289.6802, y: 45918.997859645155 },
          color: "#c0c0c0",
          text: "215：",
          sn: "B2-212",
          value: "26.0℃",
        },
        {
          id: 232,
          point: { x: 66908.95799383285, y: 45918.997859645155 },
          color: "#c0c0c0",
          text: "218北: ",
          sn: "B2-232",
          value: "26.0℃",
        },
        {
          id: 233,
          point: { x: 66876.61305511283, y: 37709.654240384 },
          color: "#c0c0c0",
          text: "218南: ",
          sn: "B2-233",
          value: "26.0℃",
        },
        {
          id: 234,
          point: { x: 81140.73103073408, y: 45918.1425908356 },
          color: "#c0c0c0",
          text: "217北: ",
          sn: "B2-234",
          value: "26.0℃",
        },
        {
          id: 235,
          point: { x: 81205.4209081741, y: 37709.4432553083 },
          color: "#c0c0c0",
          text: "217南: ",
          sn: "B2-235",
          value: "26.0℃",
        },
        {
          id: 236,
          point: { x: 92532.9149172006, y: 45918.14710059969 },
          color: "#c0c0c0",
          text: "216西北: ",
          sn: "B2-236",
          value: "26.0℃",
        },
        {
          id: 237,
          point: { x: 92692.0001318887, y: 37709.813679197105 },
          color: "#c0c0c0",
          text: "216西南: ",
          sn: "B2-237",
          value: "26.0℃",
        },
        {
          id: 238,
          point: { x: 100804.05528592147, y: 45918.883245642355 },
          color: "#c0c0c0",
          text: "216东北: ",
          sn: "B2-238",
          value: "26.0℃",
        },
        {
          id: 239,
          point: { x: 101062.81479568325, y: 37709.889055823034 },
          color: "#c0c0c0",
          text: "216东南: ",
          sn: "B2-239",
          value: "26.0℃",
        },
        // {
        //   id: 0,
        //   point: { x: 92915.36356190662, y: 37742.52274585393 },
        //   color: "#c0c0c0",
        //   text: "S4: ",
        //   sn: "",
        //   value: "26.0℃", 
        // },
        // {
        //   id: 0,
        //   point: { x: 101095.84985394301, y: 37581.490279597056 },
        //   color: "#c0c0c0",
        //   text: "S5: ",
        //   sn: "",
        //   value: "26.0℃", 
        // },
        // {
        //   id: 0,
        //   point: { x: 110427.52842558309, y: 37546.81500588606 },
        //   color: "#c0c0c0",
        //   text: "S6: ",
        //   sn: "",
        //   value: "26.0℃", 
        // },
        // {
        //   id: 0,
        //   point: { x: 63112.56605229568, y: 26475.502589082127 },
        //   color: "#c0c0c0",
        //   text: "空调机房: ",
        //   sn: "",
        //   value: "26.0℃", 
        // },
        {
          id: 202,
          point: { x: 69133.03017940576, y: 26711.997597226276 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-202",
          value: "26.0℃",
        },
        {
          id: 219,
          point: { x: 75246.47645305863, y: 26648.685453981365 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-219",
          value: "26.0℃",
        },
        {
          id: 220,
          point: { x: 79908.32823161146, y: 26648.685453981365 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-220",
          value: "26.0℃",
        },
        {
          id: 221,
          point: { x: 84402.68832949767, y: 26648.685453981365 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-221",
          value: "26.0℃",
        },
        {
          id: 203,
          point: { x: 89594.91912620491, y: 26662.611951861894 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-203",
          value: "26.0℃",
        },
        {
          id: 205,
          point: { x: 99187.52449633912, y: 26412.84835568306 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-205",
          value: "26.0℃",
        },
        {
          id: 206,
          point: { x: 103643.52860494988, y: 26499.60860425369 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-206",
          value: "26.0℃",
        },
        {
          id: 207,
          point: { x: 108244.20090721955, y: 26489.963984209753 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-207",
          value: "26.0℃",
        },
        {
          id: 208,
          point: { x: 112688.35418694053, y: 26398.30962842051 },
          color: "#c0c0c0",
          text: "",
          sn: "B2-208",
          value: "26.0℃",
        },],
      textPoint1: [{
        id: 132,
        point: { x: 22883.935648801053, y: 28371.44147947806 },
        color: "#c0c0c0",
        text: "N4: ",
        sn: "B2-132",
        value: "25.0℃",
      },
      {
        id: 134,
        point: { x: 31964.028576601268, y: 28452.0340202573 },
        color: "#c0c0c0",
        text: "N3: ",
        sn: "B2-134",
        value: "25.0℃",
      },
      {
        id: 136,
        point: { x: 40909.80641334815, y: 28398.305580871514 },
        color: "#c0c0c0",
        text: "N2: ",
        sn: "B2-136",
        value: "25.0℃",
      },
      {
        id: 138,
        point: { x: 49830.21134821161, y: 28291.224483331986 },
        color: "#c0c0c0",
        text: "N1: ",
        sn: "B2-138",
        value: "25.0℃",
      },
      {
        id: 133,
        point: { x: 23029.017759521492, y: 20521.694004420162 },
        color: "#c0c0c0",
        text: "S4: ",
        sn: "B2-133",
        value: "25.0℃",
      },
      {
        id: 135,
        point: { x: 32020.23462212739, y: 20839.264935692947 },
        color: "#c0c0c0",
        text: "S3: ",
        sn: "B2-135",
        value: "25.0℃",
      },
      {
        id: 137,
        point: { x: 41034.19528907245, y: 20796.071748995804 },
        color: "#c0c0c0",
        text: "S2: ",
        sn: "B2-137",
        value: "25.0℃",
      },
      {
        id: 139,
        point: { x: 49882.535795720745, y: 20894.704972148378 },
        color: "#c0c0c0",
        text: "S1: ",
        sn: "B2-139",
        value: "25.0℃",
      },
      {
        id: 102,
        point: { x: 16211.792164422717, y: 9099.759268016322 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-102",
        value: "25.0℃",
      },
      {
        id: 103,
        point: { x: 20592.75422892606, y: 9099.172511359488 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-103",
        value: "25.0℃",
      },
      {
        id: 105,
        point: { x: 25075.99556341782, y: 9099.016349915619 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-105",
        value: "25.0℃",
      },
      {
        id: 106,
        point: { x: 29627.417885617062, y: 9099.021888720075 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-106",
        value: "25.0℃",
      },
      {
        id: 107,
        point: { x: 34059.49725731202, y: 9099.648829837723 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-107",
        value: "25.0℃",
      },
      {
        id: 108,
        point: { x: 38730.24610212454, y: 9099.09715135816 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-108",
        value: "25.0℃",
      },
      {
        id: 109,
        point: { x: 43350.836299772025, y: 9099.043308655208 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-109",
        value: "25.0℃",
      },
      {
        id: 110,
        point: { x: 49926.41313441112, y: 9099.043308655208 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-110",
        value: "25.0℃",
      },
      {
        id: 117,
        point: { x: 60618.75241027141, y: 18422.867879249126 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-117",
        value: "25.0℃",
      },
      /* {
        id: 118,
        point: { x: 60467.39286547864, y: 24184.6716735698 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-118",
        value: "25.0℃",
      }, */
      {
        id: 119,
        point: { x: 58999.35823592536, y: 30460.54183447815 },
        color: "#c0c0c0",
        text: "",
        sn: "B2-119",
        value: "25.0℃",
      }],
      textTimer: null,
      dianliuTimer: null,
      ligOn: 'rgba(0, 81, 255, 0.5)',// 开灯
      ligOff: 'rgba(0, 81, 255, 0)',// 关灯
      marker: null,
      e5: {
        arr: [{ "name": 'VOC', "max": "1000", id: 1 },
        { "name": '温度', "max": "40", id: 2 },
        { "name": 'CO2', "max": "1000", id: 3 },
        { "name": '湿度', "max": "100", id: 4 },],
        value1: [0, 0, 0, 0],
        value2: [500, 30, 500, 50]
      },
      e6: {
        time: [],
        value1: [],
        value2: [],
        value3: [],
        value4: []
      },
      e2: {
        time: [],
        value: []
      },
      ligon: '../../../../static/img/tencent/don.png',
      ligoff: '../../../../static/img/tencent/doff.png',
      ligoff1: '../../../../static/img/tencent/doff.png',
      tempon: '../../../../static/img/tencent/xon.png',
      tempoff: '../../../../static/img/tencent/xoff.png',
      ligshow: false,
      tempsd: "26.0",
      fan1: "",
      fan2: "",
      ktdata: { // 开关空调参数
        id: "",
        value: '0'
      },
      dedata1: { // 灯光参数
        id: "",
        value: ''
      },
      dedata2: {
        id: "",
        value: ''
      },
      tempdata: { // 温度参数
        id: "",
        value: ''
      },
      leidadata: {
        id: "",
        value: ""
      },
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      testSize: 0,
      IA: [],
      IB: [],
      IC: [],
      airpt: '',
      timeDay: '',
      okceng: 5,
      ce: '五层',
      timeMode: null,
      men7: {
        id: '',
        value: "",
      },
      men8: {
        id: '',
        value: "",
      }
    }
  },
  props: {

  },
  components: {
    ToolTip,
    UILayer,
    fanone,
    timeChare,
  },
  created() {
    let _this = this;
    window.openDoor = _this.openDoor;
    window.closeDoor = _this.closeDoor;
  },
  mounted() {
    // 监测电脑锁屏
    //document.addEventListener('visibilitychange', this.handleVisibilityChange)
    this.initMap()
    // echarts数据接口
    this.getEchartsData()
    this.getEcharts()
    this.getDayData()
    this.hefeng()
    this.textTimer = setInterval(() => {
      this.getTempData()
      this.changeColor()
      this.getTime()
    }, 1000)
    this.divColor = "#5FB8C1"
    /*  this.dianliuTimer = setInterval(() => {
       this.dlEcharts()
     }, 1000) */
    this.timeMode = setInterval(() => {
      this.switchShow()
    }, 1000)
  },
  provide() {
    return {
      getMap: () => this.map,
    };
  },
  computed: {
    ...mapState({
      nodeData: "nodeTree",
      // closeStatus: 'isReloadTree',
      objectInfo: "objectInfo",
      tabPanel: "tabPanel",
      toggle: "toggle",
      loginStatus: "loginStatus",
      leftClickNode: "leftClickNode",
    }),
  },
  methods: {
    ...mapMutations({
      //记事本
      noteBookShow: "NOTE_BOOK_SHOW",
      userShow: "USER_SHOW",
      groupShow: "GROUP_SHOW",
      pointShow: "POINT_SHOW",
      stateChangeShow: "CHANGE_OF_STATE_SHOW",
      onlineChartTrendShow: "ONLINECHART_PROPERTIES_TREND_SHOW",
      alarmControlShow: "ALARM_CONTROL_SHOW",
      alarmChartDialogShow: "ALARMCHART_PROPERTIES_DIALOG_SHOW",
      userGroupAlarmShow: "GROUP_ALARM_SHOW",
      trendJournalShow: "TREND_JOURNAL_SHOW",
      timeChartShow: "TIME_CHART_SHOW",
      timeChartBatchShow: "TIME_CHART_BATCH_SHOW",
      propertiesDialogShow: "PROPERTIES_DIALOG_SHOW",
      authorityShow: "AUTHORITY_SHOW",
      onlineChartDialogShow: "ONLINECHART_PROPERTIES_DIALOG_SHOW",
      //图形化展示
      graphiCallyShow: "GRAPHI_CALLY_SHOW",
      deviceDialogShow: "DEVICE_DIALOG_SHOW",
      objectTransferShow: "OBJECT_TRANSFER_SHOW",
      timeEventObejctShow: "TIME_EVENT_OBJECT_SHOW",
      timeEventListShow: "TIME_EVENT_LIST_SHOW",
      holidayShow: "HOLIDAY_SHOW", //假期计划表
      energyDialogShow: "ENERGY_DIALOG_SHOW",// 创建的能耗计算
      energyBarShow: "ENERGY_BAR_SHOW",
      //计算工具
      countBookShow: "COUNT_BOOK_SHOW",
      // 数据接口
      dataInterfaceShow: 'DATA_INTERFACE_SHOW',
    }),
    // 空调调用时间表
    kChindren() {
      const timeChar = this.$refs.timeChar;
      if (timeChar) {
        timeChar.kongShow(this.okceng);
      }
    },
    // 灯光调用时间表
    dChindren() {
      const timeChar = this.$refs.timeChar;
      if (timeChar) {
        timeChar.dengShow(this.okceng);
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 每天的数据获取
    getDayData() {
      let obj = {
        args: ['5层能耗及碳排放量数据接口', '5层每天制热量数据接口'],
      }
      service.getPublicData(obj).then(res => {
        let a = ""
        let b = ""
        res.forEach(item => {
          if (item.secondName == "KW") {
            a = item.value
          }
          if (item.secondName == "COOL") {
            b = item.value
          }
          if (item.secondName == "五层") {
            this.len = item.value
          }
        })
        this.dian = a

        this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
        this.mtan = (this.tan / 10000).toFixed(2)
      })
    },
    // 生成地图点位  
    async initMap() {
      this.map = null
      const env = {
        serviceUrl: "https://xiaowu-iot.com/cad/api/v1",
        accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MSwiVXNlcm5hbWUiOiJyb290MSIsIk5pY2tOYW1lIjoicm9vdDEiLCJBdXRob3JpdHlJZCI6InJvb3QiLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjo0ODQwOTI1ODYxLCJpc3MiOiJ2am1hcCIsIm5iZiI6MTY4NzMyNDg2MX0.0P4hQkpOp1h7ynqjA3gMbckkG5b4PWtHSNGnWmfmJl4",
        exampleMapId: "sys_zp"
      };
      // 地图服务对象
      let svc = new vjmap.Service(env.serviceUrl, env.accessToken)
      // 打开地图  
      let res = await svc.openMap({
        mapid: this.cadId, // 地图ID
        mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      if (res.error) {
        // 如果打开出错
        console.error(res.error)
        return;
      }
      // 获取地图范围
      let mapExtent = vjmap.GeoBounds.fromString(res.bounds);
      // 根据地图范围建立几何投影坐标系
      let prj = new vjmap.GeoProjection(mapExtent);
      // 地图对象
      this.map = new vjmap.Map({
        container: this.clearMapBox(), // DIV容器ID 
        style: svc.rasterStyle(), // 样式，这里是栅格样式
        center: prj.toLngLat(mapExtent.center()), // 设置地图中心点
        zoom: 2.9,
        maxZoom: 5, // 设置地图缩放级别,
        minZoom: 2.9,
        pitch: 20, // 倾斜角度
        renderWorldCopies: false, // 不显示多屏地图
        pitchWithRotate: false,
        dragRotate: false, // 拖动旋转 
      });
      // 关联服务对象和投影对象 
      this.map.attach(svc, prj);
      await this.map.onLoad(); // 等待地图加载完成
      this.colorBlock() // 初始化色块
      this.addText() // 初始化文字
      this.createMarker()
    },
    // 清除地图的容器
    clearMapBox() {
      let parentDiv = document.getElementById("map-container");
      parentDiv.innerHTML = "";
      let newMapDiv = document.createElement("div");
      newMapDiv.id = vjmap.RandomID(6);
      newMapDiv.style.position = 'absolute';
      newMapDiv.style.width = "100%";
      newMapDiv.style.height = "100%";
      parentDiv.appendChild(newMapDiv);
      return newMapDiv.id;
    },
    // 返回
    goBack() {
      this.$router.go(-1)
      clearInterval(this.textTimer)
    },
    // 色块叠加
    colorBlock() {
      if (this.polygon) {
        this.polygon.remove()
        this.polygons = []
      }
      this.points.forEach(item => {
        let arr = []
        item.point.forEach((val, index) => {
          let pt = vjmap.geoPoint([val.x, val.y])
          arr.push(pt)
        })
        this.polygons.push({
          points: this.map.toLngLat(arr),
          properties: {
            lig: item.lig,
            name: item.name,
            color: item.color,
            sn: item.sn,
            other: item.other,
            icuId: item.icuId,
          }
        })
      })
      this.polygon = new vjmap.Polygon({
        data: this.polygons,
        // 如果是hover状态时，用红色，非hover状态时，取属性中的'color'做为颜色值
        fillColor: ['case', ['to-boolean', ['feature-state', 'hover']], ['get', 'color'], ['get', 'color']],
        fillOpacity: 0.8,
        fillOutlineColor: "rgba(255, 0, 0, 0)", //边线颜色，没错,确实没有边线宽度这个选项
        isHoverPointer: false,
        isHoverFeatureState: true
      });
      this.polygon.addTo(this.map);
      this.polygon.clickLayer(e => this.onclickBox(e.features[0].properties))
    },
    // 添加文字
    addText() {
      if (this.symbols) {
        this.symbols.remove()
      }
      this.geoDatas = []
      // 循环体
      this.textPoint.forEach((item, index) => {
        let pt = this.map.toLngLat({
          x: item.point.x, y: item.point.y
        });
        let data = {
          point: pt,
          properties: {
            name: item.text,
            value: item.value,
            sn: item.sn,
            index: item.id,
            text: `${item.text}${item.value}`, // 这个用来记录原来的文本内容
            color: item.color,
          },
        }
        this.geoDatas.push(data);
      })
      let fontHeight = 2.5;
      this.symbols = new vjmap.Symbol({
        data: this.geoDatas,
        textField: ['get', 'text'],
        textFont: ['Arial Unicode MS Regular'],
        // 文字大小，这些用表达式，表达式的作用是根据缩放级别，会自动缩放文字大小
        textSize: [
          'interpolate',
          ['exponential', 2],
          ['zoom'],
          0, ["*", fontHeight, ["^", 2, 0]],
          24, ["*", fontHeight, ["^", 2, 24]]
        ],
        textColor: ['get', 'color'],
        textOffset: [0, -0.5],
        textAnchor: 'top',
        textRotationAlignment: "map",
        textMaxWidth: 10000000, //不自动换行
        iconAllowOverlap: true,
        textAllowOverlap: true
      });
      this.symbols.addTo(this.map);
      this.getTempData()
    },
    // 获取设定温度数值
    async getTempData() {
      if (this.symbols) {
        // 修改原始数据
        let args = []
        switch (this.okceng) {
          case 1:
            args = ['一层开放办公空间空调数据接口', "一层独立办公空间空调数据接口"];
            break;
          case 2:
            args = ['二层开放办公空间空调数据接口', "二层独立办公空间空调数据接口"];
            break;
          case 3:
            args = ['三层开放办公空间空调数据接口', '三层独立办公空间空调数据接口'];
            break;
          case 4:
            args = ['四层开放办公空间空调数据接口', '四层独立办公空间空调数据接口'];
            break;
          case 5:
            args = ['开放办公空间空调设定接口', '独立办公空间空调设定接口'];
            break;
          default:
            break;
        }
        let tempIn = {
          "args": args
        }
        await service.getPublicData(tempIn).then(res => {
          res.forEach(item => {
            this.geoDatas.forEach(item1 => {
              if (item1.properties.sn == item.sn) {
                if (item.name == "AW_FANS_SPT") {
                  item1.properties.value = parseFloat(item.value).toFixed(1)
                  item1.properties.text = item1.properties.name + parseFloat(item.value).toFixed(1) + "℃"
                }
                if (item.name == "BW_FANS_ON")
                  if (item.value == 0 || item.value == null || item.value == "" || item.value == "0") {
                    item1.properties.color = "#c0c0c0"
                  } else {
                    item1.properties.color = "#15ff00"
                  }
              }
            })
          })
        })
        // 修改图层
        this.symbols.setData(this.geoDatas);
      }
    },
    // 改变色块的颜色
    async changeColor() {
      if (this.polygon) {
        let tempIn = {
          "args":
            ['开放办公空间灯光数据接口']
        }
        let obj = {
          "args": ['独立办公室灯光数据接口']
        }
        switch (this.okceng) {
          case 1:
            tempIn.args = ['一层开放办公空间灯光数据接口'];
            obj.args = ['一层独立办公室灯光数据接口']
            break;
          case 2:
            tempIn.args = ["二层开放办公空间灯光数据接口"];
            obj.args = ["二层独立办公室灯光数据接口"]
            break;
          case 3:
            tempIn.args = ['三层开放办公空间灯光数据接口'];
            obj.args = ['三层独立办公室灯光数据接口']
            break;
          case 4:
            tempIn.args = ['四层开放办公空间灯光数据接口'];
            obj.args = ['四层独立办公室灯光数据接口']
            break;
          case 5:
            tempIn.args = ['开放办公空间灯光数据接口'];
            obj.args = ['独立办公室灯光数据接口']
            break;
        }
        await service.getPublicData(tempIn).then(res => {
          res.forEach(item => {
            this.polygons.forEach(item1 => {
              if (this.okceng == 3) {
                if (item.description == item1.properties.name) {
                  if (item.value == "0") {
                    item1.properties.color = this.ligOff
                  } else {
                    item1.properties.color = this.ligOn
                  }
                }
              }
              else if (this.okceng == 2) {
                if (item.sn == item1.properties.sn) {
                  if (item.value == "0") {
                    item1.properties.color = this.ligOff
                  } else {
                    item1.properties.color = this.ligOn
                  }
                }
              }
              else {
                if (item.name == item1.properties.name) {
                  if (item.value == "0") {
                    item1.properties.color = this.ligOff
                  } else {
                    item1.properties.color = this.ligOn
                  }
                }
              }

            })
          })
        })

        await service.getPublicData(obj).then(res => {
          res.forEach(item2 => {
            this.polygons.forEach(item3 => {
              if (item2.sn == item3.properties.sn) {
                if (item2.value == "0" || item2.value == null || item2.value == "") {
                  item3.properties.color = this.ligOff
                } else {
                  item3.properties.color = this.ligOn
                }
              }
            })
          })
        })
        this.polygon.setData(this.polygons)
      }
    },
    // 点击色块
    onclickBox(val) {
      if (val.other == "空调机房") {
        this.$refs.fanOne.openShow(val.name)
      }
      else if (val.other == "门禁") {
        //   this.menShow = true
        let obgs = {
          args: ['五层门禁数据接口']
        }
        service.getPublicData(obgs).then(res => {
          res.forEach(item => {
            if (item.name == "DOW_7") {
              this.men7.id = item.id
              this.men7.value = item.id
            }
            if (item.name == "DOW_8") {
              this.men8.id = item.id
              this.men8.value = item.id
            }
          })
          if (val.name == "左侧门禁") {
            if (this.men7.value == "0") {
              this.menData = false
            } else {
              this.menData = true
            }
          }
          if (val.name == "右侧门禁") {
            if (this.men8.value == "0") {
              this.menData = false
            } else {
              this.menData = true
            }
          }
        })
      }
      else {
        let name = `${val.other}界面控制数据接口`
        this.title = val.other
        let obj = {
          "args": [name]
        }
        service.getPublicData(obj).then(res => {
          res.forEach(item => {
            if (item.name == "AIR_BA") {
              this.ktemp = parseFloat(item.value).toFixed(1)
            }
            if (item.name == "AW_FANS_SPT") {
              this.stemp = parseFloat(item.value).toFixed(1)
            }
            if (item.name == "DOW_RUN_MODE") { // 雷达
              this.leidadata.id = item.id
              if (item.value == "0") {
                this.valuecheck = true
                let a1 = document.getElementById('btn1')
                a1.style.cursor = 'pointer';
                let a2 = document.getElementById('btn2')
                a2.style.cursor = 'pointer';
                let a3 = document.getElementById('btn3')
                a3.style.cursor = 'pointer';
                let a4 = document.getElementById('btn4')
                a4.style.cursor = 'pointer';
              }
              if (item.value == "1") {
                this.valuecheck = false
                let a1 = document.getElementById('btn1')
                a1.style.cursor = 'not-allowed';
                let a2 = document.getElementById('btn2')
                a2.style.cursor = 'not-allowed';
                let a3 = document.getElementById('btn3')
                a3.style.cursor = 'not-allowed';
                let a4 = document.getElementById('btn4')
                a4.style.cursor = 'not-allowed';
              }
            }
            if (item.name == "BW_FANS_ON") { // 空调开关
              this.ktdata.id = item.id
            }
            if (item.name == "DOW_PHY_NO") {// 灯光开关
              this.dedata1.id = item.id
            }
            if (item.name == "AW_FANS_SPT") { // 温度设定
              this.tempdata.id = item.id
            }
          })
        })
        if (this.okceng == 5) {
          let obj1 = {
            deviceId: val.icuId
          }
          service.getlodayData(obj1).then(res => {
            this.qydata.cp = res.cp
            this.qydata.electricity = res.electricity
            this.qydata.totalCP = res.totalCP
            this.qydata.workHours = res.workHours
          })
        } else {
          this.qydata.cp = 0
          this.qydata.electricity = 0
          this.qydata.totalCP = 0
          this.qydata.workHours = 0
        }

        this.dialogShow = true
      }

    },
    // 空调开关
    switchKtOn() {
      if (this.valuecheck) {
        this.ktdata.value = "1"
        service.updatePhysicalPoint(this.ktdata).then(res => {
          this.$Message.success("空调开启成功")
        }).catch(err => {
          this.$Message.error("空调开启失败")
        })
      } else {
        this.$Message.info("请将雷达调制为手动模式")
      }

    },
    switchKtOff() {
      if (this.valuecheck) {
        this.ktdata.value = "0"
        service.updatePhysicalPoint(this.ktdata).then(res => {
          this.$Message.success("空调关闭成功")
        }).catch(err => {
          this.$Message.error("空调关闭失败")
        })
      } else {
        this.$Message.info("请将雷达调制为手动模式")
      }
    },
    // 调节温度
    updateTempAdd() {
      this.stemp++
      this.tempdata.value = this.stemp
      this.stemp = (this.stemp).toFixed(1)
      service.updatePhysicalPoint(this.tempdata).then(res => {
        this.$Message.success("空调温度调节成功")
      }).catch(err => {
        this.$Message.error("空调温度调节失败")
      })
    },
    updateTempDel() {
      this.stemp--
      this.tempdata.value = this.stemp
      this.stemp = (this.stemp).toFixed(1)
      service.updatePhysicalPoint(this.tempdata).then(res => {
        this.$Message.success("空调温度调节成功")
      }).catch(err => {
        this.$Message.error("空调温度调节失败")
      })
    },
    // 雷达调节
    updateLeida() {
      // true 为手动 false 为自动
      if (this.valuecheck) {
        // 手动模式
        this.leidadata.value = "0"
        let a1 = document.getElementById('btn1')
        a1.style.cursor = 'pointer';
        let a2 = document.getElementById('btn2')
        a2.style.cursor = 'pointer';
        let a3 = document.getElementById('btn3')
        a3.style.cursor = 'pointer';
        let a4 = document.getElementById('btn4')
        a4.style.cursor = 'pointer';
      } else {
        // 自动模式
        this.leidadata.value = "1"
        let a1 = document.getElementById('btn1')
        a1.style.cursor = 'not-allowed';
        let a2 = document.getElementById('btn2')
        a2.style.cursor = 'not-allowed';
        let a3 = document.getElementById('btn3')
        a3.style.cursor = 'not-allowed';
        let a4 = document.getElementById('btn4')
        a4.style.cursor = 'not-allowed';
      }
      service.updatePhysicalPoint(this.leidadata).then(res => {
        this.$Message.success("雷达模式切换成功")
      }).catch(err => {
        this.$Message.error("雷达模式切换失败")
      })
    },
    // 灯光开关
    switchLigOn() {
      if (this.valuecheck) {
        this.dedata1.value = "1"
        service.updatePhysicalPoint(this.dedata1).then(res => {
          this.$Message.success("灯光开启成功")
        }).catch(err => {
          this.$Message.error("灯光开启失败")
        })
      } else {
        this.$Message.info("请将雷达调制为手动模式")
      }

    },
    switchLigOff() {
      if (this.valuecheck) {
        this.dedata1.value = "0"
        service.updatePhysicalPoint(this.dedata1).then(res => {
          this.$Message.success("灯光关闭成功")
        }).catch(err => {
          this.$Message.error("灯光关闭失败")
        })
      } else {
        this.$Message.info("请将雷达调制为手动模式")
      }

    },
    // 创建echarts图
    getEcharts() {
      let _this = this
      let obj1 = {
        args: ["5层每天制热量数据接口", "4层每天制热量数据接口", "3层每天制热量数据接口", "2层每天制热量数据接口", "1层每天制热量数据接口"],
      }
      service.getPublicData(obj1).then(res => {
        debugger
        let f1 = 1
        let f2 = 1
        let f3 = 1
        let f4 = 1
        let f5 = 1
        res.forEach(item => {
          if (item.secondName == "五层") {
            f5 = item.value
          } else if (item.secondName == "四层") {
            f4 = item.value
          } else if (item.secondName == "三层") {
            f3 = item.value
          } else if (item.secondName == "二层") {
            f2 = item.value
          } else if (item.secondName == "一层") {
            f1 = item.value
          }
        })
        let zong = Number(f1) + Number(f2) + Number(f3) + Number(f4) + Number(f5)
        this.bi11 = ((Number(f1) / zong) * 100).toFixed(1) + "%"
        this.bi12 = ((Number(f2) / zong) * 100).toFixed(1) + "%"
        this.bi13 = ((Number(f3) / zong) * 100).toFixed(1) + "%"
        this.bi14 = ((Number(f4) / zong) * 100).toFixed(1) + "%"
        this.bi15 = ((Number(f5) / zong) * 100).toFixed(1) + "%"
        // 热功耗占比图
        this.pieOne = echarts.init(this.$refs.pieOne);
        this.pieOne.setOption(
          {
            color: ["#95E284", "#FFE368", "#4EF5FA", "#F66C6B", "#9D61B4"],
            grid: {
              top: '5%',
              left: '3%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '0%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            title: {
              text: '',
              top: 'middle',
              left: 'center',
              textStyle: {
                color: '#FEDA66',
                fontSize: 14
              }
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              show: false
            },
            series: [
              {
                name: '热功耗',
                type: 'pie',
                radius: ['40%', "80%"],
                itemStyle: {
                  borderRadius: 8
                },
                data: [
                  { value: f1, name: 'F1' },
                  { value: f2, name: 'F2' },
                  { value: f3, name: 'F3' },
                  { value: f4, name: 'F4' },
                  { value: f5, name: `F5` }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 2,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                labelLine: {
                  normal: {
                    show: true,
                    minLength: 5, // 设置最小长度，0表示始终显示
                    length: 5,   // 指引线长度
                    length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                    smooth: 0.2,  // 指引线平滑度
                    lineStyle: {
                      // 指引线样式
                      width: 1,
                      type: 'solid'
                    }
                  }
                }
              }
            ]
          }
        )
        this.pieOne.setOption({
          title: {
            text: this.bi15,
            textStyle: {
              color: '#9D61B4' // 这里设置标题颜色为红色
            }
          }
        })


        this.pieOne.on('click', function (params) {
          _this.onclickEcharts(params)
        })
      })
    },
    // 创建marker
    createMarker() {
      const popup = new vjmap.Popup({ offset: [0, -10] })
        .setHTML(`<div style="width:120px;height:50px;display:flex;justify-content:center;align-items:center;">
      <div style="width:50px;height:30px;background-color:#4EF5FA;cursor:pointer;display:flex;justify-content:center;align-items:center;border-radius: 4px;margin-right:10px" onclick="openDoor()">开 门</div>

      <div style="width:50px;height:30px;background-color:#F66C6B;cursor:pointer;display:flex;justify-content:center;align-items:center;border-radius: 4px;" onclick="closeDoor()">关 门</div>
          </div>`);
      let el = document.createElement('div');
      el.className = 'marker';
      el.style.width = '21px';
      el.style.height = '21px';
      el.style.backgroundSize = '100%';
      // 默认marker
      const marker = new vjmap.Marker(el, { offset: [0, 5] })
        .setLngLat(this.map.toLngLat({ x: 9039.421360455446, y: 11989.133784374586, z: '' }))
        .setPopup(popup)
        .addTo(this.map);


      const popup1 = new vjmap.Popup({ offset: [0, -10] })
        .setHTML(`<div style="width:120px;height:50px;display:flex;justify-content:center;align-items:center;">
      <div style="width:50px;height:30px;background-color:#4EF5FA;cursor:pointer;display:flex;justify-content:center;align-items:center;border-radius: 4px;margin-right:10px" onclick="openDoor()">开 门</div>

      <div style="width:50px;height:30px;background-color:#F66C6B;cursor:pointer;display:flex;justify-content:center;align-items:center;border-radius: 4px;" onclick="closeDoor()">关 门</div>
          </div>`);
      let el1 = document.createElement('div');
      el1.className = 'marker';
      el1.style.width = '21px';
      el1.style.height = '21px';
      el1.style.backgroundSize = '100%';
      // 默认marker
      const marker1 = new vjmap.Marker(el1, { offset: [0, 5] })
        .setLngLat(this.map.toLngLat({ x: 71362.70172085761, y: 11989.133784374586, z: '' }))
        .setPopup(popup1)
        .addTo(this.map);

      let cengobj = { x: 78641.62307621923, y: 22743.09191755792, z: '' }
      this.okceng == 1 ? cengobj = { x: 79649.78564900043, y: 24946.94679239932, z: '' } : this.okceng == 2 ? cengobj = { x: 131070.9306167776, y: 42599.36340639302, z: '' } : this.okceng == 3 ? cengobj = { x: 78675.2902497791, y: 22726.046717589023, z: '' } : this.okceng == 4 ? cengobj = { x: 78743.56078966601, y: 23365.309071910728, z: '' } : this.okceng == 5 ? cengobj = { x: 78641.62307621923, y: 22743.09191755792, z: '' } : cengobj = { x: 78641.62307621923, y: 22743.09191755792, z: '' }



      let obj = {
        args: ['B2排风机状态数据接口-CAD图用']
      }
      service.getPublicData(obj).then(res => {
        if (res[0].value == 0) {
          let el2 = document.createElement('div');
          el2.className = 'markerFanOff';
          let marker3 = new vjmap.Marker({
            element: el2,
            draggable: false,
            color: vjmap.randomColor()
          });
          // 点出文字效果
          marker3.setLngLat(this.map.toLngLat(cengobj)).addTo(this.map);
        } else {
          let el2 = document.createElement('div');
          el2.className = 'markerFanOn';
          let marker3 = new vjmap.Marker({
            element: el2,
            draggable: false,
            color: vjmap.randomColor()
          });
          // 点出文字效果
          marker3.setLngLat(this.map.toLngLat(cengobj)).addTo(this.map);
        }
      })

    },
    // 开门
    openDoor: function () {
      this.men7.value = 1
      this.men8.value = 1
      service.updatePhysicalPoint(this.men7).then(res => {
        service.updatePhysicalPoint(this.men8).then(res => {
          this.$Message.success("门禁已打开！")
        }).catch(err => {
          this.$Message.error("门禁开启失败,请联系管理员！")
        })
      }).catch(err => {
        this.$Message.error("门禁开启失败,请联系管理员！")
      })


    },
    closeDoor: function () {
      this.men7.value = 0
      this.men8.value = 0
      service.updatePhysicalPoint(this.men7).then(res => {
        service.updatePhysicalPoint(this.men8).then(res => {
          this.$Message.success("门禁已关闭！")
        }).catch(err => {
          this.$Message.error("门禁关闭失败,请联系管理员！")
        })
      }).catch(err => {
        this.$Message.error("门禁关闭失败,请联系管理员！")
      })

    },
    showinfor() {
      let _this = this
      let a = this.map.getZoom()
      let val = a.toFixed(2)
      if (val > 2.9) {
        this.echartsShow = true
      } else {
        this.echartsShow = true
        setTimeout(() => {
          _this.map.flyTo({
            center: [0, 0],
          })
        }, 10)
      }
    },
    timecharShow() {
      this.timeChartShow()
    },
    // echarts环境数据
    async getEchartsData() {
      this.e6.time = []
      this.e6.value1 = []
      this.e6.value2 = []
      this.e6.value3 = []
      this.e6.value4 = []
      let timestamp = Date.now();
      let obj = {
        "startTime": timestamp - (24 * 3600 * 1000),
        "stopTime": timestamp,
        "id": "6675270754706e63b6c3ba3b",
        "trendLogId": [
          "6675268154706e63b6c3ba37",
          "667526b654706e63b6c3ba38",
          "667526ce54706e63b6c3ba39",
          "667526e654706e63b6c3ba3a"
        ]
      }
      switch (this.okceng) {
        case 1:
          obj.id = "667d17f72622c078bc70bf70",
            obj.trendLogId = [
              "667d179a2622c078bc70bf6c",
              "667d17b02622c078bc70bf6d",
              "667d17c22622c078bc70bf6e",
              "667d17d92622c078bc70bf6f"
            ]
          break;
        case 2:
          obj.id = "667d176b2622c078bc70bf6b",
            obj.trendLogId = [
              "667d17482622c078bc70bf6a",
              "667d17372622c078bc70bf69",
              "667d17252622c078bc70bf68",
              "667d17112622c078bc70bf67"
            ]
          break;
        case 3:
          obj.id = "667d16b72622c078bc70bf66",
            obj.trendLogId = [
              "667d16392622c078bc70bf62",
              "667d164c2622c078bc70bf63",
              "667d16642622c078bc70bf64",
              "667d16782622c078bc70bf65"
            ]
          break;
        case 4:
          obj.id = "667cccbb2622c078bc70bf52",
            obj.trendLogId = [
              "667ccbf42622c078bc70bf4e",
              "667ccc252622c078bc70bf4f",
              "667ccc4d2622c078bc70bf50",
              "667ccc772622c078bc70bf51"
            ]
          break;
        case 5:
          obj.id = "6675270754706e63b6c3ba3b",
            obj.trendLogId = [
              "6675268154706e63b6c3ba37",
              "667526b654706e63b6c3ba38",
              "667526ce54706e63b6c3ba39",
              "667526e654706e63b6c3ba3a"
            ]
          break;
      }
      await service.trendLogShow(obj).then(res => {
        res[0].val.forEach(item => {
          if (item.name == "VOC趋势记录") {
            item.value.forEach(item1 => {
              let ti = item1[0].split("")
              this.e6.time.push(`${ti[11]}${ti[12]}${ti[13]}${ti[14]}${ti[15]}`)
              this.e6.value4.push(item1[1])
            })
          }
          if (item.name == "温度趋势记录") {
            item.value.forEach(item1 => {
              this.e6.value1.push(item1[1])
            })
          }
          if (item.name == "湿度趋势记录") {
            item.value.forEach(item1 => {
              this.e6.value2.push(item1[1])
            })
          }
          if (item.name == "CO2趋势记录") {
            item.value.forEach(item1 => {
              this.e6.value3.push(item1[1])
            })
          }
        })
      })
      let obj1 = {
        "startTime": timestamp - (24 * 3600 * 1000),
        "stopTime": timestamp,
        "ids": [
          "667394a1c850c4270e1c4822"
        ]
      }
      await service.getHistogram(obj1).then(res => {
        this.e2.time = []
        this.e2.value = []
        for (let i = 0; i < res[0].val[0].value.length; i++) {
          this.e2.value.push(res[0].val[0].value[i][1])
          let arr = res[0].val[0].value[i][0].split("")
          let ti = `${arr[8]}${arr[9]}`
          this.e2.time.push(ti)
        }
      })
      /* this.getEcharts() */
      let pieOne6 = echarts.init(this.$refs.pieOne6);
      pieOne6.setOption(
        {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [
              {
                name: '温度',
                icon: 'circle', // 图例的图标样式
              }, {
                name: '湿度',
                icon: 'circle', // 图例的图标样式
              }, {
                name: 'CO2',
                icon: 'circle', // 图例的图标样式
              }, {
                name: 'VOC',
                icon: 'circle', // 图例的图标样式
              },
            ],
            itemWidth: 10, // 设置图例标记的宽度
            itemHeight: 10, // 设置图例标记的高度
            textStyle: {                            //图例文字的样式
              color: '#D2D2D2',               //图例文字颜色
              fontSize: 10                     //图例文字大小
            },
            x: '59%', // 靠右侧
          },
          color: ["#00e6ff", "#0038b0", "#FFE368", "#9d61b4ac"],
          grid: {
            top: '10%',
            left: '2%', //grid 组件离容器左侧的距离。
            right: '5%', //grid 组件离容器右侧的距离。
            bottom: '2%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          xAxis: {
            boundaryGap: false,
            type: 'category',
            data: this.e6.time,
            axisLine: {
              lineStyle: {
                color: '#D2D2D2' //坐标轴线线的颜色。
              }
            },
          },
          yAxis: [{
            position: 'left',
            type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: '', //坐标轴名称。
            axisTick: {
              show: false //是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                color: '#D2D2D2', //坐标轴线线的颜色
                textStyle: {
                  fontSize: 18, //文字的字体大小
                  fontWeight: '900',
                }
              }
            },
            axisLabel: {
              margin: 10, //刻度标签与轴线之间的距离
              color: '#D2D2D2',
              textStyle: {
                fontSize: 12, //文字的字体大小
                /* fontWeight:'800', */
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#57617B' //分隔线颜色设置
              }
            }
          }, {
            max: 2000,
            min: 0,
            position: 'right',
            type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: '', //坐标轴名称。
            axisTick: {
              show: false //是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                color: '#D2D2D2', //坐标轴线线的颜色
                textStyle: {
                  fontSize: 18, //文字的字体大小
                  fontWeight: '900',
                }
              }
            },
            axisLabel: {
              margin: 10, //刻度标签与轴线之间的距离
              color: '#D2D2D2',
              textStyle: {
                fontSize: 12, //文字的字体大小
                /* fontWeight:'800', */
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#57617B' //分隔线颜色设置
              }
            }
          }],
          series: [
            {
              name: '温度',
              yAxisIndex: 0, // 使用Y轴1
              data: this.e6.value1,
              type: 'line',
              barWidth: '50%', // 设置为类目宽度的50%
              symbol: 'none',
              lineStyle: {
                width: 1 // 设置线条粗细为5
              },
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#04626c16'
                },
                {
                  offset: 1,
                  color: '#00a1b3'
                }]),
              },
              emphasis: {
                focus: 'series'
              },
            },
            {
              name: '湿度',
              yAxisIndex: 0, // 使用Y轴1
              data: this.e6.value2,
              type: 'line',
              barWidth: '50%', // 设置为类目宽度的50%
              symbol: 'none',
              lineStyle: {
                width: 0 // 设置线条粗细为5
              },
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#00277a42'
                },
                {
                  offset: 1,
                  color: '#0038b0'
                }]),
              },
              emphasis: {
                focus: 'series'
              },
            },
            {
              name: 'CO2',
              yAxisIndex: 1, // 使用Y轴1
              data: this.e6.value3,
              type: 'line',
              barWidth: '50%', // 设置为类目宽度的50%
              symbol: 'none',
              lineStyle: {
                width: 1 // 设置线条粗细为5
              }
            }, {
              name: 'VOC',
              yAxisIndex: 1, // 使用Y轴1
              data: this.e6.value4,
              type: 'line',
              barWidth: '50%', // 设置为类目宽度的50%
              symbol: 'none',
              lineStyle: {
                width: 1 // 设置线条粗细为5
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne6.resize()
      })
    },
    // 空调开关
    switchKt() {
      if (this.ktdata.value == "0") {
        this.tempoff = "../../../../static/img/tencent/xon.png"
        this.ktdata.value = "1"
      } else {
        this.tempoff = "../../../../static/img/tencent/xoff.png"
        this.ktdata.value = "0"
      }
    },
    // 灯光开关
    switchLig() {
      if (this.dedata1.value == "0") {
        this.ligoff = "../../../../static/img/tencent/don.png"
        this.dedata1.value = "1"
      } else {
        this.ligoff = "../../../../static/img/tencent/doff.png"
        this.dedata1.value = "0"
      }
    },
    // 灯光开关
    switchLig1() {
      if (this.dedata2.value == "0") {
        this.ligoff1 = "../../../../static/img/tencent/don.png"
        this.dedata2.value = "1"
      } else {
        this.ligoff1 = "../../../../static/img/tencent/doff.png"
        this.dedata2.value = "0"
      }
    },
    // 发送数据
    onSend() {
      this.tempdata.value = this.tempsd
      service.updatePhysicalPoint(this.ktdata).then(res => {
        this.$Message.success("修改成功")
      }).catch(err => {

      })
      setTimeout(() => {
        service.updatePhysicalPoint(this.dedata1).then(res => {
          this.$Message.success("修改成功")
        }).catch(err => {

        })
      }, 1000)
      setTimeout(() => {
        service.updatePhysicalPoint(this.tempdata).then(res => {
          this.$Message.success("修改成功")
        }).catch(err => {
        })
      }, 2000)
      if (this.dedata2.id == "" || this.dedata2.value == "") {
      } else {
        setTimeout(() => {
          service.updatePhysicalPoint(this.dedata2).then(res => {
            this.$Message.success("修改成功")
          }).catch(err => {
          })
        }, 3000)
      }
      this.dialogShow = false
    },
    // 电流实时曲线图
    dlEcharts() {
      let myDate = new Date();
      let house = myDate.getHours();
      let minutes = myDate.getMinutes();
      let second = myDate.getSeconds();
      let time = house + ":" + minutes + ":" + second
      let tempIn = {
        "args": ['CAD电流数据接口']
      }
      service.getPublicData(tempIn).then(res => {
        res.forEach(item => {
          if (item.name == "AIR_IA") {
            if (this.testSize > 250) {
              this.testSize = 254
              this.IA.shift()
              this.IA.push(item.value)
              this.testArray.shift() // 删除第一个数据
              this.testArray.push(time) // 向后面添加一个新数据
            } else {
              this.testArray.splice(this.testSize, 1, time) //替换数据
              this.IA.push(item.value)
            }
          }
          if (item.name == "AIR_IB") {
            if (this.testSize > 250) {
              this.testSize = 254
              this.IB.shift()
              this.IB.push(item.value)
            } else {
              this.IB.push(item.value)
            }
          }
          if (item.name == "AIR_IC") {
            if (this.testSize > 250) {
              this.testSize = 254
              this.IC.shift()
              this.IC.push(item.value)
            } else {
              this.IC.push(item.value)
            }
          }
        })
        this.testSize++

        let pieOne3 = echarts.init(this.$refs.pieOne3);
        pieOne3.setOption(
          {
            tooltip: {
              trigger: 'axis'
            },
            color: ["#FAC11D", "#18C920", "#EE2400"],
            grid: {
              top: '10%',
              left: '3%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '15%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            xAxis: {
              boundaryGap: false,
              type: 'category',
              data: this.testArray,
              axisLine: {
                lineStyle: {
                  color: '#1E90FF' //坐标轴线线的颜色。
                }
              },
              axisLabel: {
                fontSize: 10 // 设置文字大小为10
              }
            },
            yAxis: [{
              type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
              name: '', //坐标轴名称。
              axisTick: {
                show: false //是否显示坐标轴刻度
              },
              axisLine: {
                lineStyle: {
                  color: '#1E90FF', //坐标轴线线的颜色
                  textStyle: {
                    fontSize: 10, //文字的字体大小
                    fontWeight: '900',
                  }
                }
              },
              axisLabel: {
                margin: 10, //刻度标签与轴线之间的距离
                color: '#1E90FF',
                textStyle: {
                  fontSize: 10, //文字的字体大小
                  /* fontWeight:'800', */
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#57617B' //分隔线颜色设置
                }
              }
            }],
            series: [
              {
                name: "AIR_IA",
                data: this.IA,
                type: 'line',
                barWidth: '50%', // 设置为类目宽度的50%
                symbol: 'none',
                lineStyle: {
                  width: 1 // 设置线条粗细为5
                }
              },
              {
                name: "AIR_IB",
                data: this.IB,
                type: 'line',
                barWidth: '50%', // 设置为类目宽度的50%
                symbol: 'none',
                lineStyle: {
                  width: 1 // 设置线条粗细为5
                }
              },
              {
                name: "AIR_IC",
                data: this.IC,
                type: 'line',
                barWidth: '50%', // 设置为类目宽度的50%
                symbol: 'none',
                lineStyle: {
                  width: 1 // 设置线条粗细为5
                }
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne3.resize()
        })
      })
      this.timeDay = moment().format('YYYY-MM-DD HH:mm:ss');
    },
    // 点击切换cad图
    onclickEcharts(e) {
      clearInterval(this.timeMode)
      this.timeMode = setInterval(() => {
        this.switchShow()
      })
      // let mapIds = "c87f4c542c89"
      let arr = e.name.split(":")[0]
      clearInterval(this.textTimer)
      if (arr == "F1") {
        this.ce = "一层"
        this.okceng = 1
        this.pieOne.setOption({
          title: {
            text: this.bi11,
            textStyle: {
              color: '#95E284' // 这里设置标题颜色为红色
            }
          }
        })
        this.textPoint = this.textPoint1
        this.points = this.points1
        this.cadId = "c1ad6ea9293a"
        this.titleMain = "江宁基地B2建筑1层"
        this.getEchartsData()
        this.textTimer = setInterval(() => {
          this.getTempData()
          this.changeColor()
          this.getTime()
        }, 1000)
        let obj = {
          args: ['1层能耗及碳排放量数据接口', "1层每天制热量数据接口"]
        }
        service.getPublicData(obj).then(res => {
          let a = ""
          let b = ""
          res.forEach(item => {
            if (item.secondName == "KW") {
              a = item.value
            }
            if (item.secondName == "COOL") {
              b = item.value
            }
            if (item.secondName == "一层") {
              this.len = item.value
            }
          })
          this.dian = a
          this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
          this.mtan = (this.tan / 10000).toFixed(2)
        })
      }
      if (arr == "F2") {
        this.ce = "二层"
        this.okceng = 2
        this.pieOne.setOption({
          title: {
            text: this.bi12,
            textStyle: {
              color: '#FFE368' // 这里设置标题颜色为红色
            }
          }
        })
        this.textPoint = this.textPoint2
        this.points = this.points2
        this.cadId = "c68b34e4ec76"
        this.titleMain = "江宁基地B2建筑2层"
        this.getEchartsData()
        this.textTimer = setInterval(() => {
          this.getTempData()
          this.changeColor()
          this.getTime()
        }, 1000)
        let obj = {
          args: ['2层能耗及碳排放量数据接口', "2层每天制热量数据接口"]
        }
        service.getPublicData(obj).then(res => {
          let a = ""
          let b = ""
          res.forEach(item => {
            if (item.secondName == "KW") {
              a = item.value
            }
            if (item.secondName == "COOL") {
              b = item.value
            }
            if (item.secondName == "二层") {
              this.len = item.value
            }
          })
          this.dian = a
          this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
          this.mtan = (this.tan / 10000).toFixed(2)
        })
      }
      if (arr == "F3") {
        this.ce = "三层"
        this.okceng = 3
        this.pieOne.setOption({
          title: {
            text: this.bi13,
            textStyle: {
              color: '#4EF5FA' // 这里设置标题颜色为红色
            }
          }
        })
        this.textPoint = this.textPoint3
        this.points = this.points3
        this.cadId = "c6db9329ba89"
        this.titleMain = "江宁基地B2建筑3层"
        this.getEchartsData()
        this.textTimer = setInterval(() => {
          this.getTempData()
          this.changeColor()
          this.getTime()
        }, 1000)
        let obj = {
          args: ['3层能耗及碳排放量数据接口', "3层每天制热量数据接口"]
        }
        service.getPublicData(obj).then(res => {
          let a = ""
          let b = ""
          res.forEach(item => {
            if (item.secondName == "KW") {
              a = item.value
            }
            if (item.secondName == "COOL") {
              b = item.value
            }
            if (item.secondName == "三层") {
              this.len = item.value
            }
          })
          this.dian = a
          // this.len = b
          this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
          this.mtan = (this.tan / 10000).toFixed(2)
        })
      }
      if (arr == "F4") {
        this.ce = "四层"
        this.okceng = 4
        this.pieOne.setOption({
          title: {
            text: this.bi14,
            textStyle: {
              color: '#F66C6B' // 这里设置标题颜色为红色
            }
          }
        })
        this.textPoint = this.textPoint4
        this.points = this.points4
        this.cadId = "c05194bfa03b"
        this.titleMain = "江宁基地B2建筑4层"
        this.getEchartsData()
        this.textTimer = setInterval(() => {
          this.getTempData()
          this.changeColor()
          this.getTime()
        }, 1000)
        let obj = {
          args: ['4层能耗及碳排放量数据接口', "4层每天制热量数据接口"]
        }
        service.getPublicData(obj).then(res => {
          let a = ""
          let b = ""
          res.forEach(item => {
            if (item.secondName == "KW") {
              a = item.value
            }
            if (item.secondName == "COOL") {
              b = item.value
            }
            if (item.secondName == "四层") {
              this.len = item.value
            }
          })
          this.dian = a
          //this.len = b
          this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
          this.mtan = (this.tan / 10000).toFixed(2)
        })
      }
      if (arr == "F5") {
        this.ce = "五层"
        this.okceng = 5
        this.pieOne.setOption({
          title: {
            text: this.bi15,
            textStyle: {
              color: '#9D61B4' // 这里设置标题颜色为红色
            }
          }
        })
        this.textPoint = this.textPoint5
        this.points = this.points5
        this.cadId = "c45cc7e84c29"
        this.titleMain = "江宁基地B2建筑5层"
        this.getEchartsData()
        this.getDayData()
        this.textTimer = setInterval(() => {
          this.getTempData()
          this.changeColor()
          this.getTime()
        }, 1000)
      }
      this.initMap()
    },
    // 获取时间
    getTime() {
      // 获取系统时间
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if (hour == 12) {
        this.divColor = "#ffffff"
        this.divColor1 = "#6EDCE4"
        this.divColor2 = "#ffffff"
      }
      if (hour == 13) {
        if (minute <= 30) {
          this.divColor = "#ffffff"
          this.divColor1 = "#6EDCE4"
          this.divColor2 = "#ffffff"
        }
      }
      let second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      let timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      this.homeTime = timer
      // 室外温度实时获取
      /* let obj9 = {
        args: ['室外温度数据接口']
      }
      service.getPublicData(obj9).then(res => {
        this.templ = parseFloat(res[0].value).toFixed(1)
      }) */
    },
    // 和风天气数据接口 cb8885d03abc4412ab83212e87a4fddf
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101190101&key=cb8885d03abc4412ab83212e87a4fddf',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.templ = data.now.temp
            this.weather = data.now.text
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    },
    switchShow() {
      let date = new Date();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if (hour == 12) {
        this.divColor = "#ffffff"
        this.divColor1 = "#6EDCE4"
        this.divColor2 = "#ffffff"
      }
      else if (hour == 13) {
        if (minute <= 30) {
          this.divColor = "#ffffff"
          this.divColor1 = "#6EDCE4"
          this.divColor2 = "#ffffff"
        }
      }
      else {
        this.divColor = "#6EDCE4"
        this.divColor1 = "#ffffff"
        this.divColor2 = "#ffffff"
      }
    },
    switchModel(val) {
      clearInterval(this.timeMode)
      let _this = this
      let id = ""
      let kid = ""
      this.okceng == 5 ? id = "664b1472a75b1f15aba811b6" : this.okceng == 4 ? id = "6655edb3461227632c6bf045" : this.okceng == 3 ? id = "665d6926fd783077c42d0a6c" : this.okceng == 2 ? id = "6662ae4a274e9b40d3cb331e" : this.okceng == 1 ? id = "66656f34b389a374a011eed2" : ""

      this.okceng == 5 ? kid = "664b14c8a75b1f15aba811b7" : this.okceng == 4 ? kid = "6655edda461227632c6bf046" : this.okceng == 3 ? kid = "665d694efd783077c42d0a6d" : this.okceng == 2 ? kid = "6662aee2274e9b40d3cb331f" : this.okceng == 1 ? kid = "66656f41b389a374a011eed3" : ""
      if (val == 1) {
        this.divColor = "#6EDCE4"
        this.divColor1 = "#ffffff"
        this.divColor2 = "#ffffff"
        service.groupControl(kid, "DOW_RUN_MODE", "1").then(res => {
          this.$message.success("开启雷达模式")
        })
        service.fanCheck(kid).then(res => {
          //this.$message.success("雷达模式开启")
        })
      }
      if (val == 2) {
        this.divColor = "#ffffff"
        this.divColor1 = "#6EDCE4"
        this.divColor2 = "#ffffff"
        if (this.okceng == 5) {
          // 先关闭雷达
          service.groupControl(kid, "DOW_RUN_MODE", "0").then(res => {
            this.$message.success("关闭雷达")
            setTimeout(() => {
              // 关闭灯光
              service.groupControl(kid, "DOW_PHY_NO", "0").then(res => {
                this.$message.success("关闭灯光")
                setTimeout(() => {
                  // 打开空调
                  service.groupControl(kid, "BW_FANS_ON", "1").then(res => {
                    this.$message.success("关打开空调")
                  })
                }, 1000)
              })
            }, 1000)
          })
        }
      }
      if (val == 3) {
        this.divColor = "#ffffff"
        this.divColor1 = "#ffffff"
        this.divColor2 = "#6EDCE4"
        this.$Message.success("一键控制")
        if (this.okceng == 5) {
          // 先关闭雷达
          service.groupControl(kid, "DOW_RUN_MODE", "0").then(res => {
            this.$message.success("关闭雷达")
            setTimeout(() => {
              // 关闭灯光
              service.groupControl(kid, "DOW_PHY_NO", "0").then(res => {
                this.$message.success("关闭灯光")
                setTimeout(() => {
                  // 关闭空调
                  service.groupControl(kid, "BW_FANS_ON", "0").then(res => {
                    this.$message.success("关闭空调")
                  })
                }, 1000)
              })
            }, 1000)
          })
        }
      }
    },
    updateKaimen() {

    }
  },
  destroyed() {
    clearInterval(this.textTimer)
    clearInterval(this.dianliuTimer)
    clearInterval(this.timeMode)
  },
  beforeDestroy() {
    clearInterval(this.textTimer)
    clearInterval(this.dianliuTimer)
    clearInterval(this.timeMode)
  }
}
</script>

<style lang="scss" scoped>
.flexc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.n_content {
  width: 100%;
  height: 100%;
  background-color: #0A0B1D;
  /*  background-image: url('../../../../static/img/sicon/back.jpg');
  background-size: 100% 100%; */
  position: relative;
  overflow: hidden;
}

#map-container {
  position: absolute;
  top: 13%;
  z-index: 10;
  width: 100%;
  height: 100%;
}

.timechart {
  position: absolute;
  top: 32%;
  left: 5%;
  z-index: 11;
  width: 80px;
  height: 60px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.timechart1 {
  position: absolute;
  top: 32%;
  right: 5%;
  z-index: 11;
  width: 80px;
  height: 60px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.n_header {
  width: 100%;
  height: 60px;
  position: absolute;
  z-index: 997;
  background-image: url("../../../../static/img/diy/002.png");
  background-size: 100% 100%;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px 10px 20px;

  .n_header_tit {
    width: 30%;
    font-size: 2.5vh;
    color: #D2D2D2;
    font-weight: 800;
  }

  .n_header_icon {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      cursor: pointer;
      width: 20px;
      height: 20px;
    }
  }
}

.ech_box_header {
  width: 300px;
  height: 300px;
  position: absolute;
  z-index: 998;
  top: 30px;
  left: 46px;
  color: #5781ff;
  font-weight: 900;
}

.ech_box_header1 {
  position: absolute;
  z-index: 998;
  right: 60px;
  top: 30px;
  color: #89a5fb;
  font-weight: 900;
}

.ech_box2 {
  width: 15%;
  height: 140px;
  position: absolute;
  z-index: 998;
  top: 60px;
  left: 20%;

}

.ech_box3 {
  width: 30%;
  height: 140px;
  position: absolute;
  z-index: 998;
  top: 60px;
  left: 35%;

}

.ech_box4 {
  width: 15%;
  height: 140px;
  position: absolute;
  z-index: 998;
  top: 60px;
  left: 65%;
}

.ech_box5 {
  width: 15%;
  height: 170px;
  position: absolute;
  z-index: 998;
  top: 50px;
  right: 3%;
}


.dialog_box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, 0.659);
  right: 0;
  top: 0%;

  .dialog_box_main {
    width: 640px;
    height: 380px;
    background-color: #20212F;
    border-radius: 5px;


    .dialog_box_header {
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      padding: 0 10px 0 10px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;



      .dialog_box_header_tit {
        font-size: 2vh;
        color: #D2D2D2;
        font-weight: 800;
      }

      i {
        font-size: 20px;
        color: #D2D2D2;
        cursor: pointer;
      }
    }

    .dialog_box_header_bom {
      width: 100%;
      height: 2px;
      background-image: linear-gradient(to right, #204da733 0%, #204CA7 50%, #204da733 100%);
    }

    .dialog_box_body {
      width: 100%;
      height: 350px;
      box-sizing: border-box;
      padding: 0px 10px 10px 10px;
      display: flex;

      .dialog-left {
        width: 49%;
        height: 100%;
        box-sizing: border-box;
        padding: 30px 0 0 0;

        .dialog-right_top {
          width: 100%;
          height: 64px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          padding: 0 0 20px 0;

          span {
            font-size: 1.5vh;
            color: #fff;
          }
        }

        .dialog-left-top {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          .temp_btn_box {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            margin-bottom: 2%;
            padding: 0px 45px 0px 45px;
          }

          .temp_btn_on {
            width: 43%;
            height: 85%;
            background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.5vh;
            color: #fff;
            cursor: pointer;

            img {
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
          }

          .temp_btn_on:hover {
            box-shadow: 0 0 10px 0 #8e8e8e;
          }
        }

        .dialog-left-bottom {
          width: 100%;
          height: 130px;
          display: flex;
          justify-content: center;
          align-items: center;

          .bottom_btn {
            width: 50px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 5vh;
            font-weight: 800;
            color: #567693;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0px 0px 10px 0px;
          }

          .data_temp_box {
            width: 110px;
            height: 110px;
            background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
            border-radius: 50%;
            box-sizing: border-box;
            padding: 10px 10px;

            .s_temp {
              width: 100%;
              height: 50%;
              border-bottom: 2px solid #A4B5C5;

              .temp_tit {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                font-size: 1.5vh;
                color: #fff;
              }

              .tepm_data {
                width: 100%;
                height: 38px;
                display: flex;
                justify-content: center;
                align-items: center;

                .temp_data_num {
                  height: 100%;
                  font-size: 1.5vh;
                  color: #69D0D8;
                }

                .temp_data_unit {
                  height: 100%;
                  font-size: 1.5vh;
                  color: #69D0D8;
                }
              }
            }

            .k_temp {
              width: 100%;
              height: 50%;
              box-sizing: border-box;
              padding-top: 5px;

              .temp_tit {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                font-size: 1.5vh;
                color: #fff;
              }

              .tepm_data {
                width: 100%;
                height: 38px;
                display: flex;
                justify-content: center;
                align-items: center;

                .temp_data_num {
                  height: 100%;
                  font-size: 1.5vh;
                  color: #69D0D8;
                }

                .temp_data_unit {
                  height: 100%;
                  font-size: 1.5vh;
                  color: #69D0D8;
                }
              }
            }
          }
        }
      }

      .dialog-center {
        width: 2px;
        height: 90%;
        background-image: linear-gradient(to top, #204ba816 0%, #204CA8 100%);
      }

      .dialog-right {
        width: 49%;
        height: 100%;

        .dialog-right_top {
          width: 100%;
          height: 64px;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            font-size: 2vh;
            color: #E1E4E6;
            font-weight: 800;
          }
        }

        .dialog-right_bottom {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 30px 10px 20px 10px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;

          .bottom-box1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 30px;

            .bottom-box-left {
              width: 35%;
              height: 40px;
              line-height: 40px;
              text-align: left;
              font-size: 1.5vh;
              color: #fff;
              /* background-color: #1C2844; */
            }

            .bottom-box-right {
              width: 49%;
              height: 40px;
              line-height: 40px;
              padding-left: 3px;
              font-size: 1.5vh;
              text-align: center;
              background-color: #2A2D40;
              color: #69D0D8;
            }
          }
        }
      }

      .dialog_body_temp {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        margin-top: 10px;

      }

    }
  }


}

.btn_box {
  width: 60px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border: 1px solid #0052e0;
  border-radius: 2px;
  font-size: 13px;
  color: #0052e0;
  cursor: pointer;
}

.bottom_box {
  width: 100%;
  height: 168px;
  position: absolute;
  z-index: 996;
  bottom: 0;
  display: flex;

  .bottom_box1 {
    width: 18%;
    height: 100%;
    box-sizing: border-box;
    padding-left: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-bottom: 15px;

    .bottom1_tit {
      color: #1E90FF;
      font-size: 13px;

    }
  }

  .bottom_box2 {
    width: 100%;
    height: 100%;
  }
}

.header_time {
  position: absolute;
  z-index: 997;
  top: 20px;
  left: 60%;
  height: 20px;
  color: #1E90FF;
}

.header_data {
  position: absolute;
  z-index: 997;
  top: 20px;
  left: 30%;
  height: 20px;
  color: #1E90FF;
}

.time_box {
  position: absolute;
  z-index: 999;
  top: 33%;
  left: 3%;
  width: 80px;
  height: 60px;

}

.time_char_box {
  width: 100%;
  height: 30px;
  cursor: pointer;

  img {
    width: 30px;
    height: 30px;
  }

  .time_char_tit {
    width: 100%;
    text-align: center;
    color: #4EB4D8;
    font-size: 13px;
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.s {
  color: rgba(0, 81, 255, 0);
  background-color: rgba(126, 126, 126, 0.406);
  /* color: #7cff24; 空调开 */
  color: #15ff00;
}

.btn-icon {
  width: 30%;
  height: 90%;
  cursor: pointer;
  font-size: 1.5vh;
  color: #fff;
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
  border-radius: 5px;
}

.btn-icon:hover {
  box-shadow: 0 0px 10px #8f8f8f;
}

.btn-icon-tit {
  width: 68%;
  height: 90%;
  font-size: 1.4vh;
  color: #909090;
  line-height: 1.1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.echarts_top {
  width: 100%;
  height: 28%;
  position: relative;
  z-index: 996;
  /* background-image: linear-gradient(to top, #001023 0%, #001F46 100%);*/
  padding-top: 80px;
  top: 0;
  left: 0;
  box-sizing: border-box;
  /* padding-top: 60px; */

  .echarts_top_box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 50px 0 50px;

    .box-header {
      width: 49.5%;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .box-header-left {
        width: 49%;
        height: 100%;
        background-color: #262835c7;
        box-sizing: border-box;
        padding: 5px 5px 5px 4%;
        border-radius: 4px;

        .ech_header {
          width: 100%;
          font-size: 2vh;
          color: #D2D2D2;
          display: flex;
          align-items: center;

          .ling-box {
            width: 1vh;
            height: 1vh;
            margin-right: 2%;
            border-radius: 2px;
            transform: rotate(45deg);
          }
        }
      }

      .box-header-right {
        width: 100%;
        height: 100%;
        background-color: #262835c7;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .box-header-right-l {
          width: 75%;
          height: 100%;
        }

        .box-header-right-line {
          width: 2px;
          height: 90%;
          background-color: #454760;
        }

        .box-header-right-r {
          width: 24%;
          height: 100%;
        }
      }
    }

    .ech_box {
      width: 16%;
      height: 100%;

      .ech_header {
        width: 100%;
        color: #D2D2D2;
        font-size: 13px;
        font-weight: 900;
      }
    }

  }
}

.echarts_bottom {
  width: 100%;
  height: 75%;
  position: relative;
  z-index: 9;





  /* background-image: linear-gradient(to top, #001023 0%, #001023 100%); */
  bottom: 0;
}

.input_box {
  background-color: transparent;
  color: #27C4F9;
}

.switch_diy>>>.el-switch__core {
  height: 20px !important;
  width: 50px !important;
  border-radius: 15px !important;
  border: 1px solid #9ED8F6 !important;
}

.switch_diy>>>.el-switch__core:after {
  top: -0.5px;
  width: 19px;
  height: 19px;
  margin-left: -1px;
  background-color: #9ED8F6;
}

.switch_diy>>>.el-switch.is-checked .el-switch__core:after {
  margin-left: -19px;
}

.S {
  color: rgba(0, 81, 255, 0.432);
}

.men-box {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.659);

  .men-box-main {
    width: 300px;
    height: 200px;
    background-color: #20212F;
    border-radius: 4px;

    .men-box-main-header {
      width: 100%;
      height: 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px 0 15px;
    }

    .men_box_header_bom {
      width: 100%;
      height: 2px;
      background-image: linear-gradient(to right, #204da733 0%, #204CA7 50%, #204da733 100%);
    }

    .men_box_body {
      width: 100%;
      height: 160px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 70px 0 70px;
    }
  }
}
</style>
<style>
.markerFanOn {
  width: 40px;
  height: 40px;
  background-image: url('../../../assets/diy/xuan.gif');
  background-size: 100% 100%;
}

.markerFanOff {
  width: 30px;
  height: 30px;
  background-image: url('../../../assets/diy/xuan1.png');
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/nari/index.vue